import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  Maps,
  ImageExport,
  MapsComponent,
  MapsModule,
} from '@syncfusion/ej2-angular-maps';
import { italyMap } from '../../../../../../shared/italy-regions';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import PptxGenJS from 'pptxgenjs';
import { NtMedicineInterface } from '../../../../../../shared/interfaces/nt-medicine.interface';
import { CommonModule } from '@angular/common';
import { NtOpenToAccessMapInterface } from '../../../../../../shared/interfaces/nt-openToAccess-map-interface';
import { NtChartRegionInterface } from '../../../../../../shared/interfaces/nt-chart-region.interface';
import { WIDGET_LAYOUT } from '../../../../../../shared/interfaces/widgetLayout';
import { TOOLTIPS_NT } from '../../../../../../shared/data/tooltipsNT.data';
import { TooltipsInterface } from '../../../../../../shared/interfaces/nt-tooltips';
import { ActivitySummaryDTO } from '../../../../../../shared/interfaces/activity-summary.interface';
import { InclusionProcessToolNational } from '../../../../../../shared/interfaces/nt-inclusion-process-tool';
import { TimelineEvolutionRegionalMarket30Days } from '../../../../../../shared/interfaces/nt-EvolutionRegionalMarket30days.interface';
import { CustomizeNationalReportComponent } from '../customize-national-report/customize-national-report.component';

Maps.Inject(ImageExport);

type ForecastAccuracyRow = {
  mese: string;
  forecast: number | null;
  actual: number | null;
  delta: number | null;
};

@Component({
  selector: 'app-generate-national-report',
  imports: [MapsModule, CommonModule, CustomizeNationalReportComponent],
  templateUrl: './generate-national-report.component.html',
  styleUrl: './generate-national-report.component.css',
})
export class GenerateNationalReportComponent {
  @Input() medicineInfoData: NtMedicineInterface = {
    id: 0,
    businessName: '',
    creationDate: '',
    activeSubstance: '',
    therapeuticArea: '',
    therapeuticIndication: '',
    therapeuticIndicationAcronym: '',
    reimbursementClass: '',
    supplyClass: '',
    atc: '',
    aic: '',
    openToAccessType: '',
    medicineBrandInfo: {
      font: { title: '', subtitle: '' },
      colors: { title: '', subtitle: '', background: '' },
      logo: { url: '', altText: 'Logo' },
    },
    launched: false,
    imported: false,
    tags: [],
    active: false,
  };
  @Input() widgetsAvailable: WIDGET_LAYOUT[] = [];
  @Input() isCustomHeatmapOpenToMarket: boolean = false;
  @Input() customHeatmapDataInReport: NtPotentialRegionInterface[] = [];
  @Output() isModalOpen = new EventEmitter<boolean>();

  @ViewChild('experienceMap') experienceMap!: MapsComponent;
  @ViewChild('regAccessMap') regAccessMap!: MapsComponent;
  @ViewChild('heatmap') heatmap!: MapsComponent;
  @ViewChild('heatmapEconomia') heatmapEconomia!: MapsComponent;
  @ViewChild('heatmapMerged') heatmapMerged!: MapsComponent;

  experienceMapBase64String: any = '';
  regAccessMapBase64String: any = '';
  heatmapBase64String: any = '';
  processMessage: string = '';

  public regionName: string | null | undefined;
  public medicineName: string = '';
  public medicineId = 1;

  public countryId = 1;

  public regionId = 1;

  public companyId = 1;

  public layersExpMap?: object[];
  public layersRegAccessMap?: object[];
  public layersHeatmap?: object[];
  public layersHeatmapEconomia?: object[];
  public layersHeatmapMerged?: object[];
  today: Date = new Date();
  heatmapColor: string = '';
  heatmapRegionalInclusionColor: string = '';

  heatmapEconomiaBase64String: any = '';
  heatmapEconomiaColor: string = '';
  heatmapMergedBase64String: any = '';
  tooltipsNT: TooltipsInterface[] = TOOLTIPS_NT;

  inclusionProcessData: InclusionProcessToolNational | null = null;
  isCustomizationDone: boolean = false;

  constructor(
    private us: DmtUtilityService,
    private dataService: DataService,
  ) {}

  medicineInfoHeader = [
    { text: 'PRINCIPIO\nATTIVO', options: { bold: true, fill: 'FFFFFF' } },
    {
      text: 'CLASSE DI\nRIMBORSABILITÀ',
      options: { bold: true, fill: 'FFFFFF' },
    },
    { text: 'AREA\nTERAPEUTICA', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'CLASSE DI\nFORNITURA', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'ATC', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'AIC', options: { bold: true, fill: 'FFFFFF' } },
  ];

  medicineTherapeuticInfoHeader = [
    {
      text: 'INDICAZIONE TERAPEUTICA',
      options: { bold: true, fill: 'FFFFFF' },
    },
  ];

  medicineTableData: any[] = [];
  medicineTherapeuticInfoTableData: any[] = [];

  activitySummaryHeader = [
    {
      text: 'ATTIVITÀ',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: '#',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'STAKEHOLDERS',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'COMPLETATA',
      options: { bold: true, fill: 'CCF7DD', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'IN CORSO',
      options: { bold: true, fill: 'FFECA1', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'IN RITARDO',
      options: {
        bold: true,
        fill: 'FDE0E0',
        align: 'center',
        fontSize: 7.5,
      },
    },
    {
      text: 'NESSUNA DATA',
      options: { bold: true, fill: 'FAFAFA', align: 'center', fontSize: 7.5 },
    },
  ];

  openToAccessAndMarketHeader: any[] = [
    {
      text: 'DATA',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'Δ',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  monitorinForecastvsActualHeader: any[] = [
    {
      text: 'REGIONE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'MESI FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'MESI ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'Δ',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  regionalAccessHeader = [
    {
      text: 'REGIONE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'DATA FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'DOVE SIAMO',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  inclusionStartHeader: any[] = [
    {
      text: 'LIVELLO',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  inclusionRegionHeader: any[] = [
    {
      text: 'REGIONE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  inclusionAcquistoHeader: any[] = [
    {
      text: 'REGIONE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'OSPEDALE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  forecastAccuracyHeader: any[] = [
    {
      text: 'MESE',
      options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 7.5 },
    },
    {
      text: 'FORECAST',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'ACTUAL',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
    {
      text: 'Δ',
      options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 7.5 },
    },
  ];

  experienceTotal: number = 0;
  hospitalsTotalNumber: number = 0;
  totalNumbersExperienceAndHospitalsTable: any;

  experienceAndHospitalsTotalHeader = [
    {
      text: 'NUMERO TOTALE ESPERIENZE',
      options: { bold: true, fill: 'FFFFFF' },
    },
    {
      text: 'NUMERO TOTALE OSPEDALI',
      options: { bold: true, fill: 'FFFFFF' },
    },
  ];

  openToAccessTableRows: any[] = [];
  openToAccessTableData: any[] = [];

  openToMarketTableRows: any[] = [];
  openToMarketTableData: any[] = [];

  openToEconomiaTableRows: any[] = [];
  openToEconomiaTableData: any[] = [];

  activitySummaryData: ActivitySummaryDTO[] = [];
  activitySummaryTableRows: any[][] = [];

  regionalAccessEvolutionData: any[] = [];
  regionalAccessEvolutionTableDataActual: any[] = [];
  regionalAccessEvolutionTableData: any[] = [];
  regionalMarketEvolutionTableDataActual: any[] = [];
  regionalMarketEvolutionTableDataForecast: any[] = [];
  regionalMarketEvolutionData: any[] = [];

  regionalEconomiaEvolutionTableDataActual: any[] = [];
  regionalEconomiaEvolutionTableDataForecast: any[] = [];
  regionalEconomiaEvolutionData: any[] = [];

  regionalMarket30DaysEvolutionTableDataActual: any[] = [];
  regionalMarket30DaysEvolutionTableDataForecast: any[] = [];
  regionalMarket30DaysEvolutionData: any[] = [];

  experienceMapData: NtPotentialRegionInterface[] = [];
  experienceMapTableData: any[] = [];
  leftExpMapTableRows: any[] = [];
  rightExpMapTableRows: any[] = [];

  regionalAccessMapData: NtOpenToAccessMapInterface[] = [];

  heatmapData: NtPotentialRegionInterface[] = [];
  heatmapTableData: any[] = [];
  leftHeatmapTableRows: any[] = [];
  rightHeatmapTableRows: any[] = [];

  heatmapInEconomiaData: NtPotentialRegionInterface[] = [];
  heatmapInEconomiaTableData: any[] = [];
  leftHeatmapInEconomiaTableRows: any[] = [];
  rightHeatmapInEconomiaTableRows: any[] = [];

  heatmapMergedTableData: any[] = [];
  leftHeatmapMergedTableRows: any[] = [];
  rightHeatmapMergedTableRows: any[] = [];

  monitoringForecastvsActualData: any[] = [];
  monitoringForecastvsActualTableData: any[] = [];
  leftMonitoringForecastvsActualTableRows: any[] = [];
  rightMonitoringForecastvsActualTableRows: any[] = [];

  regionalAccessData: any[] = [];
  regionalAccessTableData: any[] = [];
  leftRegionalAccessTableRows: any[] = [];
  rightRegionalAccessTableRows: any[] = [];

  monitoringCompleteAccessData: any[] = [];
  leftMonitoringCompleteAccessTableRows: any[] = [];
  rightMonitoringCompleteAccessTableRows: any[] = [];

  inclusionStartTableData: any[] = [];
  leftInclusionRegionaleTableRows: any[] = [];
  rightInclusionRegionaleTableRows: any[] = [];
  leftInclusionAggiudicazioneTableRows: any[] = [];
  rightInclusionAggiudicazioneTableRows: any[] = [];
  inclusionAcquistoTableRows: any[] = [];

  forecastAccuracyOpenToAccessData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };
  forecastAccuracyOpenToEconomiaData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };
  forecastAccuracyOpenToMarketData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };

  forecastAccuracyOpenToAccessRows: ForecastAccuracyRow[] = [];
  forecastAccuracyOpenToEconomiaRows: ForecastAccuracyRow[] = [];
  forecastAccuracyOpenToMarketRows: ForecastAccuracyRow[] = [];

  MonitoringAggiuducazioneGaraData: any[] = [];
  leftMonitoringAggiudicazioneTableRows: any[] = [];
  rightMonitoringAggiudicazioneTableRows: any[] = [];

  // Default brand info in case of missing data
  DEFAULT_MEDICINE_BRAND = {
    font: { title: 'Arial, sans-serif', subtitle: 'Helvetica, sans-serif' },
    colors: { title: '#141F58', subtitle: '#00CEBC', background: '#FFFFFF' },
    logo: { url: '', altText: 'Logo' },
  };

  brandInfoMedicine = this.DEFAULT_MEDICINE_BRAND;

  monthNamesIt = [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ];

  public openToAccessChartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };

  public openToMarketChartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };

  public openToEconomiaChartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: [],
  };

  openToAccessLabels: string[] = [];
  openToAccessTargetData: (number | null)[] = [];
  openToAccessActualData: (number | null)[] = [];

  openToMarketLabels: string[] = [];
  openToMarketTargetData: (number | null)[] = [];
  openToMarketActualData: (number | null)[] = [];

  openToEconomiaLabels: string[] = [];
  openToEconomiaTargetData: (number | null)[] = [];
  openToEconomiaActualData: (number | null)[] = [];

  // widget-curva-mercato-30-giorni (id: 21)
  openToMarket30DaysLabels: string[] = [];
  openToMarket30DaysTargetData: (number | null)[] = [];
  openToMarket30DaysActualData: (number | null)[] = [];
  openToMarket30DaysTableData: any[] = [];
  openToMarket30DaysMergedTableData: any[] = [];
  openToMarket30DaysForecastPeriods: string[] = [];
  openToMarket30DaysActualPeriods: string[] = [];

  /*ngOnInit(): void {
if(this.isCustomizationDone){
  this.startLoading();
}
  }*/

  // totalCalls and generated slides are limited to the selected ones
  onWidgetsSelected(selectedIds: number[]): void {
    this.widgetsAvailable = this.widgetsAvailable.filter((w) =>
      selectedIds.includes(w.id),
    );
  }

  onCustomizationSelected(): void {
    this.isCustomizationDone = true;
    this.startLoading();
  }

  startLoading(){
    this.getSessionVariables();

    let completedCalls = 0;
    // count only widgets that need api calls
    let totalCalls = 0;

    // count how many api calls we will make
    // those are the widgets that require data fetching
    [
      0, 5, 1, 2, 6, 3, 4, 21, 23, 7, 8, 10, 22, 12, 13, 15, 16, 20, 17, 18, 19,
    ].forEach((id) => {
      if (this.widgetsAvailable.some((w) => w.id === id)) totalCalls++;
    });
    // 21 and 23 share the same call: count it once
    if (this.hasOpenToMarket30DaysWidget(21) && this.hasOpenToMarket30DaysWidget(23)) {
      totalCalls--;
    }

    // call this when each data arrives
    const dataLoaded = () => {
      completedCalls++;
      if (completedCalls === totalCalls) {
        this.openModal();
      }
    };

    // if none of the selected widgets need api calls (e.g. only 9, 11, 14), open modal immediately
    if (totalCalls === 0) {
      this.openModal();
    }

    // NO CONDITIONAL CALL
    this.dataService
      .getNationalExperienceAndHospitalInfo(this.medicineId, this.countryId)
      .subscribe((data) => {
        this.experienceTotal = data.experienceTotal;
        this.hospitalsTotalNumber = data.hosptialsTotalNumber;
      });

    // widget-inclusion-process-tool (Processo di Inclusione)
    if (this.widgetsAvailable.some((w) => w.id === 14)) {
      this.dataService
        .getInclusionProcessSummary(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.inclusionProcessData = data;
        });
    }

    // CONDITIONAL CALLS

    // widget-esperienze-map
    if (this.widgetsAvailable.some((w) => w.id === 0)) {
      this.dataService
        .getRegioniData(this.medicineId, this.countryId)
        .subscribe((data: any) => {
          this.experienceMapData = data;
          dataLoaded();
        });
    }
    // widget-mapOpenAccess
    if (this.widgetsAvailable.some((w) => w.id === 5)) {
      this.dataService
        .getHeatmapRegionalAccessData(this.medicineId, this.countryId)
        .subscribe((data: any) => {
          this.regionalAccessMapData = data;
          dataLoaded();
        });
    }
    // widget-heatmap
    if (this.widgetsAvailable.some((w) => w.id === 1)) {
      //this.dataService.getRegioniHeatmapData(this.medicineId, this.countryId)
      this.dataService
        .getHeatmapInfo(this.companyId, this.medicineId, this.countryId)
        .subscribe((data: any) => {
          if (!this.isCustomHeatmapOpenToMarket) {
            this.heatmapData = data;
          } else {
            this.heatmapData = [...this.customHeatmapDataInReport];
          }
          this.heatmapData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }
    // widget-attivita
    if (this.widgetsAvailable.some((w) => w.id === 2)) {
      this.dataService
        .getActivitySummary(
          this.companyId.toString(),
          this.medicineId.toString(),
        )
        .subscribe((data) => {
          this.activitySummaryData = data;
          this.activitySummaryData.sort((a, b) =>
            a.activityName.localeCompare(b.activityName),
          );
          dataLoaded();
        });
    }
    // widget-evolution-regional-access
    if (this.widgetsAvailable.some((w) => w.id === 6)) {
      this.dataService
        .getRegionalAccessEvolutionData(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.regionalAccessEvolutionData = data;
          dataLoaded();
        });
    }

    // widget-evolution-regional-market
    if (this.widgetsAvailable.some((w) => w.id === 10)) {
      this.dataService
        .getOpenToMarketEvolution(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.regionalMarketEvolutionData = data;
          dataLoaded();
        });
    }

    // widget-evolution-regional-market-30-days (id: 22)
    if (this.widgetsAvailable.some((w) => w.id === 22)) {
      this.dataService
        .getOpenToMarketEvolution30Days(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.regionalMarket30DaysEvolutionData = data;
          dataLoaded();
        });
    }

    // widget-evolution-regional-economia (id: 20)
    if (this.widgetsAvailable.some((w) => w.id === 20)) {
      this.dataService
        .getOpenToEconomiaEvolution(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.regionalEconomiaEvolutionData = data;
          dataLoaded();
        });
    }

    // widget-curva-accesso
    if (this.widgetsAvailable.some((w) => w.id === 3)) {
      this.dataService
        .getOpenToAccessChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.openToAccessChartData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          if (this.openToAccessChartData?.labels?.length) {
            this.openToAccessLabels = this.openToAccessChartData.labels.map(
              (dp) => this.formatDatePointToAxis(dp),
            );
            this.openToAccessTargetData = this.buildCumulativeSeries(
              this.openToAccessChartData.labels,
              this.openToAccessChartData.target,
            );
            this.openToAccessActualData = this.buildCumulativeSeries(
              this.openToAccessChartData.labels,
              this.openToAccessChartData.actual,
              { capToCurrentMonth: true },
            );
          }
          dataLoaded();
        });
    }

    // widget-curva-mercato
    if (this.widgetsAvailable.some((w) => w.id === 4)) {
      this.dataService
        .getOpenToMarketChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.openToMarketChartData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          if (this.openToMarketChartData?.labels?.length) {
            this.openToMarketLabels = this.openToMarketChartData.labels.map(
              (dp) => this.formatDatePointToAxis(dp),
            );
            this.openToMarketTargetData = this.buildCumulativeSeries(
              this.openToMarketChartData.labels,
              this.openToMarketChartData.target,
            );
            this.openToMarketActualData = this.buildCumulativeSeries(
              this.openToMarketChartData.labels,
              this.openToMarketChartData.actual,
              { capToCurrentMonth: true },
            );
          }
          dataLoaded();
        });
    }

    // widget-curva-mercato-30-giorni (id: 21) and widget-curva-mercato-30-giorni-merged (id: 23): same data
    if (this.hasOpenToMarket30DaysWidget(21) || this.hasOpenToMarket30DaysWidget(23)) {
      this.dataService
        .getOpenToMarketChartInfo30Days(this.medicineId, this.countryId)
        .subscribe({
          next: (data) => {
            this.buildOpenToMarket30DaysSeries(data);
            dataLoaded();
          },
          // don't block the report if the curve fails: the slide is just skipped
          error: () => dataLoaded(),
        });
    }
    // widget-monitoringForecastVsActualRegionalLevel
    if (this.widgetsAvailable.some((w) => w.id === 7)) {
      this.dataService
        .getRegionalAccessMonitoringData(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.monitoringForecastvsActualData = data;
          this.monitoringForecastvsActualData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }
    // widget-forecastTimeProgress
    if (this.widgetsAvailable.some((w) => w.id === 8)) {
      this.dataService
        .regionalAccessInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.regionalAccessData = data;
          this.regionalAccessData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }
    // widget-monitoringCompleteAccess
    if (this.widgetsAvailable.some((widget) => widget.id === 12)) {
      this.dataService
        .getForecastVsActualCompleteAccess(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.monitoringCompleteAccessData = data;
          this.monitoringCompleteAccessData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }
    // widget-monitoringAggiudicazione
    if (this.widgetsAvailable.some((w) => w.id === 13)) {
      this.dataService
        .getMonitoringAggiuducazioneGara(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data) => {
          this.MonitoringAggiuducazioneGaraData = data;
          this.MonitoringAggiuducazioneGaraData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }

    // widget heatmap-economia id 15
    if (this.widgetsAvailable.some((w) => w.id === 15)) {
      this.dataService
        .getHeatmapinfoPossInEconomia(
          this.companyId,
          this.medicineId,
          this.countryId,
        )
        .subscribe((data: any) => {
          this.heatmapInEconomiaData = data;
          this.heatmapInEconomiaData.sort((a, b) =>
            a.regionName.localeCompare(b.regionName),
          );
          dataLoaded();
        });
    }

    // widget-curva-economia id 16 TO CHANGE with new endpoints when ready
    if (this.widgetsAvailable.some((w) => w.id === 16)) {
      this.dataService
        .getOpenToEconomiaChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.openToEconomiaChartData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          if (this.openToEconomiaChartData?.labels?.length) {
            this.openToEconomiaLabels = this.openToEconomiaChartData.labels.map(
              (dp) => this.formatDatePointToAxis(dp),
            );
            this.openToEconomiaTargetData = this.buildCumulativeSeries(
              this.openToEconomiaChartData.labels,
              this.openToEconomiaChartData.target,
            );
            this.openToEconomiaActualData = this.buildCumulativeSeries(
              this.openToEconomiaChartData.labels,
              this.openToEconomiaChartData.actual,
              { capToCurrentMonth: true },
            );
          }
          dataLoaded();
        });
    }

    // widget-forecast-accuracy-openToAccess id 17
    if (this.widgetsAvailable.some((w) => w.id === 17)) {
      this.dataService
        .getOpenToAccessChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.forecastAccuracyOpenToAccessData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          dataLoaded();
        });
    }

    // widget-forecast-accuracy-openToEconomia id 18
    if (this.widgetsAvailable.some((w) => w.id === 18)) {
      this.dataService
        .getOpenToEconomiaChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.forecastAccuracyOpenToEconomiaData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          dataLoaded();
        });
    }

    // widget-forecast-accuracy-openToMarket id 19
    if (this.widgetsAvailable.some((w) => w.id === 19)) {
      this.dataService
        .getOpenToMarketChartInfo(this.medicineId, this.countryId)
        .subscribe((data) => {
          this.forecastAccuracyOpenToMarketData = data ?? {
            labels: [],
            actual: [],
            real: [],
            target: [],
          };
          dataLoaded();
        });
    }

    this.brandInfoMedicine =
      JSON.parse(sessionStorage.getItem('brandMedicine') ?? 'null') ??
      this.DEFAULT_MEDICINE_BRAND;

    // to apply brandInfoMedicine.colors.title to all the headers
    this.applyBrandToAllHeaders();
  }

  getSessionVariables() {
    this.regionName = localStorage.getItem('regionName');
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
    this.regionId = this.us.getSessionVariableNumber('regionId');
    this.medicineName = sessionStorage.getItem('businessName') || '';
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
  }

  openModal(): void {
    this.processMessage = 'Elaborazione dei dati...';

    (async () => {
      try {
        if (this.widgetsAvailable.some((w) => w.id === 0)) {
          this.processMessage =
            'Caricamento dei dati della mappa Esperienze per Regione...';
          await this.loadExperienceMap();
        }

        if (this.widgetsAvailable.some((w) => w.id === 5)) {
          this.processMessage =
            'Caricamento dei dati della mappa Heatmap Inclusione Regionale...';
          await this.loadRegAccessMap();
        }

        if (this.widgetsAvailable.some((w) => w.id === 1)) {
          this.processMessage =
            'Caricamento dei dati della mappa Heatmap Apertura Ospedaliera...';
          await this.loadHeatmap();
        }

        if (this.widgetsAvailable.some((w) => w.id === 15)) {
          this.processMessage =
            'Caricamento dei dati della mappa Heatmap Economia...';
          await this.loadHeatmapEconomia();

          this.processMessage =
            'Caricamento dei dati della mappa Heatmap Economia Merged...';
          await this.loadHeatmapMerged();
        }

        if (this.hasOpenToMarket30DaysWidget(21) || this.hasOpenToMarket30DaysWidget(23)) {
          this.processMessage =
            'Caricamento dei dati della Curva di Apertura Ospedaliera 30 Giorni...';
          await this.loadOpenToMarket30Days();
        }

        this.processMessage = 'Generazione di tabelle...';
        await this.generateTables();

        this.processMessage = 'Esportazione della presentazione...';
        await this.generatePPT();

        this.processMessage = 'Presentazione generata con successo!';
      } catch (error) {
        console.error('Error during PowerPoint generation:', error);
        this.processMessage = 'An error occurred. Please try again.';
      }
    })();
  }

  async generateTables(): Promise<void> {
    //Medicine Info table
    const med: NtMedicineInterface = this.medicineInfoData ?? {};

    const medicineTableRows = [
      [
        {
          text: med.activeSubstance ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: med.reimbursementClass ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: med.therapeuticArea ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: med.supplyClass ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: med.atc ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: med.aic ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ],
    ];

    const medicineTherapeuticInfoRows = [
      [
        {
          text: med.therapeuticIndication ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ],
    ];

    this.medicineTableData = [this.medicineInfoHeader, ...medicineTableRows];

    this.medicineTherapeuticInfoTableData = [
      this.medicineTherapeuticInfoHeader,
      ...medicineTherapeuticInfoRows,
    ];
    ///////////////////////
    const totalNumbersInfoRows = [
      [
        {
          text: this.experienceTotal ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: this.hospitalsTotalNumber ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ],
    ];

    this.totalNumbersExperienceAndHospitalsTable = [
      this.experienceAndHospitalsTotalHeader,
      ...totalNumbersInfoRows,
    ];

    //Experience Map Table
    this.experienceMapTableData = this.experienceMapData.map((item) => {
      // format at 2 decimals
      let percentageText = '-';
      if (item.percentage !== undefined && item.percentage !== null) {
        const numValue =
          typeof item.percentage === 'string'
            ? parseFloat(item.percentage)
            : item.percentage;
        if (!isNaN(numValue)) {
          percentageText = `${numValue.toFixed(2)}%`;
        }
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: percentageText,
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ];
    });

    const half = Math.ceil(this.experienceMapTableData.length / 2);

    this.leftExpMapTableRows = this.experienceMapTableData.slice(0, half);
    this.rightExpMapTableRows = this.experienceMapTableData.slice(half);

    //Heatmap Table
    this.heatmapTableData = this.heatmapData.map((item) => {
      // format at 2 decimals
      let percentageText = '-';
      if (item.percentage !== undefined && item.percentage !== null) {
        const numValue =
          typeof item.percentage === 'string'
            ? parseFloat(item.percentage)
            : item.percentage;
        if (!isNaN(numValue)) {
          percentageText = `${numValue.toFixed(2)}%`;
        }
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: percentageText,
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ];
    });
    const halfHeatmap = Math.ceil(this.heatmapTableData.length / 2);
    this.leftHeatmapTableRows = this.heatmapTableData.slice(0, halfHeatmap);
    this.rightHeatmapTableRows = this.heatmapTableData.slice(halfHeatmap);

    //Heatmap In Economia Table - regions with inEconomia === false show "No step"
    this.heatmapInEconomiaTableData = this.heatmapInEconomiaData.map((item) => {
      // format at 2 decimals
      let percentageText = '-';
      if (!item.inEconomia) {
        percentageText = 'No step';
      } else if (item.percentage !== undefined && item.percentage !== null) {
        const numValue =
          typeof item.percentage === 'string'
            ? parseFloat(item.percentage)
            : item.percentage;
        if (!isNaN(numValue)) {
          percentageText = `${numValue.toFixed(2)}%`;
        }
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: percentageText,
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ];
    });
    const halfHeatInEconomiamap = Math.ceil(
      this.heatmapInEconomiaTableData.length / 2,
    );
    this.leftHeatmapInEconomiaTableRows = this.heatmapInEconomiaTableData.slice(
      0,
      halfHeatInEconomiamap,
    );
    this.rightHeatmapInEconomiaTableRows =
      this.heatmapInEconomiaTableData.slice(halfHeatInEconomiamap);

    //Heatmap Merged Table - all regions with real values, inEconomia flag ignored
    this.heatmapMergedTableData = this.heatmapInEconomiaData.map((item) => {
      let percentageText = '-';
      if (item.percentage !== undefined && item.percentage !== null) {
        const numValue =
          typeof item.percentage === 'string'
            ? parseFloat(item.percentage)
            : item.percentage;
        if (!isNaN(numValue)) {
          percentageText = `${numValue.toFixed(2)}%`;
        }
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: percentageText,
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
      ];
    });
    const halfHeatMergedmap = Math.ceil(this.heatmapMergedTableData.length / 2);
    this.leftHeatmapMergedTableRows = this.heatmapMergedTableData.slice(
      0,
      halfHeatMergedmap,
    );
    this.rightHeatmapMergedTableRows =
      this.heatmapMergedTableData.slice(halfHeatMergedmap);

    // Activity Summary Table
    this.activitySummaryTableRows = this.activitySummaryData.map((item) => {
      return [
        {
          text: item.activityName ?? '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'left',
          },
        },
        {
          text: item.totalCount != null ? `${item.totalCount}` : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'center',
          },
        },
        {
          text: item.stakeholders?.length ? item.stakeholders.join(', ') : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'left',
          },
        },
        {
          text: item.completedCount != null ? `${item.completedCount}` : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'center',
          },
        },
        {
          text: item.inProgressCount != null ? `${item.inProgressCount}` : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'center',
          },
        },
        {
          text: item.delayedCount != null ? `${item.delayedCount}` : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'center',
          },
        },
        {
          text: item.noDataCount != null ? `${item.noDataCount}` : '-',
          options: {
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            align: 'center',
          },
        },
      ];
    });

    // Evolution Regional Access Table - UNIFIED

    const sortedAccess = [...this.regionalAccessEvolutionData].sort((a, b) =>
      a.datePoint.localeCompare(b.datePoint),
    );

    const sorted: any[] = [];
    sortedAccess.forEach((item, i) => {
      sorted.push(item);

      const next = sortedAccess[i + 1];
      if (next) {
        const [year, month] = this.faToYm(item.datePoint).split('-').map(Number);
        let date = new Date(year, month, 1);

        while (this.faToYm(date) < this.faToYm(next.datePoint)) {
          sorted.push({ datePoint: this.faToYm(date), forecast: [], actual: [] });
          date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }
      }
    });

    // header
    const headerRow = [
      {
        text: '',
        options: {
          bold: true,
          align: 'center',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 6.8,
          color: this.brandInfoMedicine.colors.title,
          fill: 'FFFFFF',
        },
      },
      ...sorted.map((item) => {
        const label = this.formatDatePointToIt(item.datePoint ?? '');

        return {
          text: label,
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 6.8,
            color: this.brandInfoMedicine.colors.title,
            fill: 'FFFFFF',
          },
        };
      }),
    ];

    // forecast
    const forecastRow = [
      {
        text: 'Forecast',
        options: {
          bold: true,
          align: 'center',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 7.5,
          color: '#00CEBC',
          fill: '#EFFDFC',
        },
      },
      ...sorted.map((item) => ({
        text: item.forecast
          ? item.forecast
              .map((regionName: string) => this.formatRegionName(regionName))
              .join(', ')
          : '',
        options: {
          align: 'left',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 6.5,
          color: '000000',
        },
      })),
    ];

    // actual
    const actualRow = [
      {
        text: 'Actual',
        options: {
          bold: true,
          align: 'center',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 7.5,
          color: '#141E58',
          fill: '#F1F5FF',
        },
      },
      ...sorted.map((item) => ({
        text: item.actual
          ? item.actual
              .map((regionName: string) => this.formatRegionName(regionName))
              .join(', ')
          : '',
        options: {
          align: 'left',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 6.5,
          color: '000000',
        },
      })),
    ];

    // Unified table
    this.regionalAccessEvolutionTableData = [headerRow, forecastRow, actualRow];

    // Evolution Regional Market Table - UNIFIED
    if (
      this.regionalMarketEvolutionData &&
      this.regionalMarketEvolutionData.length > 0
    ) {
      const sortedMarketData = [...this.regionalMarketEvolutionData].sort(
        (a, b) => a.datePoint.localeCompare(b.datePoint),
      );

      const sortedMarket: any[] = [];
      sortedMarketData.forEach((item, i) => {
        sortedMarket.push(item);

        const next = sortedMarketData[i + 1];
        if (next) {
          const [year, month] = this.faToYm(item.datePoint)
            .split('-')
            .map(Number);
          let date = new Date(year, month, 1);

          while (this.faToYm(date) < this.faToYm(next.datePoint)) {
            sortedMarket.push({
              datePoint: this.faToYm(date),
              forecast: [],
              actual: [],
            });
            date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          }
        }
      });

      // header
      const headerRow = [
        {
          text: '',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 6.8,
            color: this.brandInfoMedicine.colors.title,
            fill: 'FFFFFF',
          },
        },
        ...sortedMarket.map((item) => {
          const label = this.formatDatePointToIt(item.datePoint ?? '');
          return {
            text: label,
            options: {
              bold: true,
              align: 'center',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.8,
              color: this.brandInfoMedicine.colors.title,
              fill: 'FFFFFF',
            },
          };
        }),
      ];

      // forecast
      const forecastRow = [
        {
          text: 'Forecast',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#00CEBC',
            fill: '#EFFDFC',
          },
        },
        ...sortedMarket.map((item) => {
          let regionNames = '';
          if (item.forecast && item.forecast[0] && item.forecast[0].regions) {
            regionNames = item.forecast[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // actual
      const actualRow = [
        {
          text: 'Actual',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#141E58',
            fill: '#F1F5FF',
          },
        },
        ...sortedMarket.map((item) => {
          let regionNames = '';
          if (item.actual && item.actual[0] && item.actual[0].regions) {
            regionNames = item.actual[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // Unified table
      this.regionalMarketEvolutionTableDataForecast = [
        headerRow,
        forecastRow,
        actualRow,
      ];
    }

    // Evolution Regional Market 30 Days Table
    if (
      this.regionalMarket30DaysEvolutionData &&
      this.regionalMarket30DaysEvolutionData.length > 0
    ) {
      const monthIndexOf = (datePoint: string): number => {
        const m = String(datePoint).match(/(\d+)/);
        return m ? Number(m[1]) : 0;
      };

      const sortedMarket30Days = [
        ...this.regionalMarket30DaysEvolutionData,
      ].sort((a, b) => monthIndexOf(a.datePoint) - monthIndexOf(b.datePoint));

      // fill missing periods, for example Month 11 -> Month 13 adds an empty "Mese 12"
      const filledMarket30Days: TimelineEvolutionRegionalMarket30Days[] = [];
      sortedMarket30Days.forEach((item, i) => {
        const current = monthIndexOf(item.datePoint);
        filledMarket30Days.push({ ...item, datePoint: 'Mese ' + current });

        const next = sortedMarket30Days[i + 1];
        if (next) {
          for (
            let missing = current + 1;
            missing < monthIndexOf(next.datePoint);
            missing++
          ) {
            filledMarket30Days.push({
              datePoint: 'Mese ' + missing,
              forecast: [],
              actual: [],
              forecastStartDate: '',
              actualStartDate: '',
              forecastStartPeriodDate: '',
              forecastEndPeriodDate: '',
              actualStartPeriodDate: '',
              actualEndPeriodDate: '',
            });
          }
        }
      });

      // header
      const headerRow = [
        {
          text: '',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 6.8,
            color: this.brandInfoMedicine.colors.title,
            fill: 'FFFFFF',
          },
        },
        ...filledMarket30Days.map((item) => {
          return {
            text: item.datePoint,
            options: {
              bold: true,
              align: 'center',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.8,
              color: this.brandInfoMedicine.colors.title,
              fill: 'FFFFFF',
            },
          };
        }),
      ];

      // forecast
      const forecastRow = [
        {
          text: 'Forecast',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#00CEBC',
            fill: '#EFFDFC',
          },
        },
        ...filledMarket30Days.map((item) => {
          let regionNames = '';
          if (item.forecast && item.forecast[0] && item.forecast[0].regions) {
            regionNames = item.forecast[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // actual
      const actualRow = [
        {
          text: 'Actual',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#141E58',
            fill: '#F1F5FF',
          },
        },
        ...filledMarket30Days.map((item) => {
          let regionNames = '';
          if (item.actual && item.actual[0] && item.actual[0].regions) {
            regionNames = item.actual[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // Unified table
      this.regionalMarket30DaysEvolutionTableDataForecast = [
        headerRow,
        forecastRow,
        actualRow,
      ];
    }

    // Evolution Regional Economia Table - UNIFIED
    if (
      this.regionalEconomiaEvolutionData &&
      this.regionalEconomiaEvolutionData.length > 0
    ) {
      const sortedEconomiaData = [...this.regionalEconomiaEvolutionData].sort(
        (a, b) => a.datePoint.localeCompare(b.datePoint),
      );

      const sortedEconomia: any[] = [];
      sortedEconomiaData.forEach((item, i) => {
        sortedEconomia.push(item);

        const next = sortedEconomiaData[i + 1];
        if (next) {
          const [year, month] = this.faToYm(item.datePoint)
            .split('-')
            .map(Number);
          let date = new Date(year, month, 1);

          while (this.faToYm(date) < this.faToYm(next.datePoint)) {
            sortedEconomia.push({
              datePoint: this.faToYm(date),
              forecast: [],
              actual: [],
            });
            date = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          }
        }
      });

      // header
      const headerRow = [
        {
          text: '',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 6.8,
            color: this.brandInfoMedicine.colors.title,
            fill: 'FFFFFF',
          },
        },
        ...sortedEconomia.map((item) => {
          const label = this.formatDatePointToIt(item.datePoint ?? '');
          return {
            text: label,
            options: {
              bold: true,
              align: 'center',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.8,
              color: this.brandInfoMedicine.colors.title,
              fill: 'FFFFFF',
            },
          };
        }),
      ];

      // forecast
      const forecastRow = [
        {
          text: 'Forecast',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#00CEBC',
            fill: '#EFFDFC',
          },
        },
        ...sortedEconomia.map((item) => {
          let regionNames = '';
          if (item.forecast && item.forecast[0] && item.forecast[0].regions) {
            regionNames = item.forecast[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // actual
      const actualRow = [
        {
          text: 'Actual',
          options: {
            bold: true,
            align: 'center',
            fontFace: this.brandInfoMedicine.font.title,
            fontSize: 7.5,
            color: '#141E58',
            fill: '#F1F5FF',
          },
        },
        ...sortedEconomia.map((item) => {
          let regionNames = '';
          if (item.actual && item.actual[0] && item.actual[0].regions) {
            regionNames = item.actual[0].regions
              .map((r: any) => this.formatRegionName(r.name))
              .join(', ');
          }
          return {
            text: regionNames,
            options: {
              align: 'left',
              fontFace: this.brandInfoMedicine.font.title,
              fontSize: 6.5,
              color: '000000',
            },
          };
        }),
      ];

      // Unified table
      this.regionalEconomiaEvolutionTableDataForecast = [
        headerRow,
        forecastRow,
        actualRow,
      ];
    }

    //Open to Access Table
    this.openToAccessTableRows = this.openToAccessChartData.labels.map(
      (labelMonth, idx) => {
        const [year, month] = labelMonth.split('-');
        const dateText = `${month}/${year}`;

        const forecastVal = this.openToAccessTargetData[idx];
        const forecastText =
          forecastVal != null ? `${forecastVal.toFixed(2)}%` : '-';

        const actualVal = this.openToAccessActualData[idx];
        const actualText = actualVal != null ? `${actualVal.toFixed(2)}%` : '-';

        const delta =
          forecastVal != null && actualVal != null
            ? Math.round((actualVal - forecastVal) * 100) / 100
            : null;

        const deltaText =
          delta != null ? `${delta > 0 ? '+' : ''}${delta.toFixed(2)}%` : '-';

        const deltaFill = this.getDeltaFillColor({
          mese: '',
          forecast: forecastVal,
          actual: actualVal,
          delta,
        });

        return [
          {
            text: dateText,
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: forecastText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: actualText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: deltaText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: deltaFill,
            },
          },
        ];
      },
    );

    this.openToAccessTableData = [
      this.openToAccessAndMarketHeader,
      ...this.openToAccessTableRows,
    ];

    //Open to Market Table
    this.openToMarketTableRows = this.openToMarketChartData.labels.map(
      (labelMonth, idx) => {
        const [year, month] = labelMonth.split('-');
        const dateText = `${month}/${year}`;

        const forecastVal = this.openToMarketTargetData[idx];
        const forecastText =
          forecastVal != null ? `${forecastVal.toFixed(2)}%` : '-';

        const actualVal = this.openToMarketActualData[idx];
        const actualText = actualVal != null ? `${actualVal.toFixed(2)}%` : '-';

        const delta =
          forecastVal != null && actualVal != null
            ? Math.round((actualVal - forecastVal) * 100) / 100
            : null;

        const deltaText =
          delta != null ? `${delta > 0 ? '+' : ''}${delta.toFixed(2)}%` : '-';

        const deltaFill = this.getDeltaFillColor({
          mese: '',
          forecast: forecastVal,
          actual: actualVal,
          delta,
        });

        return [
          {
            text: dateText,
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: forecastText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: actualText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: deltaText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: deltaFill,
            },
          },
        ];
      },
    );

    this.openToMarketTableData = [
      this.openToAccessAndMarketHeader,
      ...this.openToMarketTableRows,
    ];

    // Open to Economia Table
    this.openToEconomiaTableRows = this.openToEconomiaChartData.labels.map(
      (labelMonth, idx) => {
        const [year, month] = labelMonth.split('-');
        const dateText = `${month}/${year}`;

        const forecastVal = this.openToEconomiaTargetData[idx];
        const forecastText =
          forecastVal != null ? `${forecastVal.toFixed(2)}%` : '-';

        const actualVal = this.openToEconomiaActualData[idx];
        const actualText = actualVal != null ? `${actualVal.toFixed(2)}%` : '-';

        const delta =
          forecastVal != null && actualVal != null
            ? Math.round((actualVal - forecastVal) * 100) / 100
            : null;

        const deltaText =
          delta != null ? `${delta > 0 ? '+' : ''}${delta.toFixed(2)}%` : '-';

        const deltaFill = this.getDeltaFillColor({
          mese: '',
          forecast: forecastVal,
          actual: actualVal,
          delta,
        });

        return [
          {
            text: dateText,
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: forecastText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: actualText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: deltaText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: deltaFill,
            },
          },
        ];
      },
    );

    this.openToEconomiaTableData = [
      this.openToAccessAndMarketHeader,
      ...this.openToEconomiaTableRows,
    ];

    //Monitoring Forecast vs Actual
    this.monitoringForecastvsActualTableData =
      this.monitoringForecastvsActualData.map((item) => {
        // Conditional background for Δ column
        let deltaFill = 'FFFFFF'; // default white

        if (item.delta < 0) {
          deltaFill = 'CCF7DD'; // light green
        } else if (item.delta > 0) {
          deltaFill = 'FDE0E0'; // light red
        }

        return [
          {
            text: this.formatRegionName(item.regionName ?? '-'),
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text: item.forecast?.toString() ?? '-',
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text: item.actual?.toString() ?? '-',
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text:
              item.delta > 0 ? `+${item.delta}` : (item.delta?.toString() ?? '-'),
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              fill: deltaFill, // <--- conditional background color
            },
            color: '000000',
          },
        ];
      });

    const halfMonitoringForecastvsActual = Math.ceil(
      this.monitoringForecastvsActualTableData.length / 2,
    );
    const leftMFARows = this.monitoringForecastvsActualTableData.slice(
      0,
      halfMonitoringForecastvsActual,
    );
    const rightMFARows = this.monitoringForecastvsActualTableData.slice(
      halfMonitoringForecastvsActual,
    );

    this.leftMonitoringForecastvsActualTableRows = [
      this.monitorinForecastvsActualHeader,
      ...leftMFARows,
    ];

    this.rightMonitoringForecastvsActualTableRows = [
      this.monitorinForecastvsActualHeader,
      ...rightMFARows,
    ];

    // MONITORAGGIO ACCESSO COMPLETO - FORECAST VS ACTUAL
    if (
      this.monitoringCompleteAccessData &&
      this.monitoringCompleteAccessData.length > 0
    ) {
      // save original data in a different variable
      const rawMonitoringData = [...this.monitoringCompleteAccessData];

      // transform data in row with security checks
      const monitoringCompleteAccessRows = rawMonitoringData.map((item) => {
        let deltaFill = 'FFFFFF'; // default white

        const delta = item.delta ?? 0;
        if (delta < 0) {
          deltaFill = 'CCF7DD'; // light green
        } else if (delta > 0) {
          deltaFill = 'FDE0E0'; // light red
        }

        let deltaText = delta > 0 ? `+${delta}` : `${delta}`;
        if (item.forecast == null || item.actual == null) {
          deltaText = '-';
          deltaFill = 'FFFFFF';
        }

        return [
          {
            text: this.formatRegionName(item.regionName ?? '-'),
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text: item.forecast?.toString() ?? '-',
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text: item.actual?.toString() ?? '-',
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
            },
            color: '000000',
          },
          {
            text: deltaText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              fill: deltaFill,
            },
            color: '000000',
          },
        ];
      });

      const halfMonitoringCompleteAccess = Math.ceil(
        monitoringCompleteAccessRows.length / 2,
      );

      const leftMCARows = monitoringCompleteAccessRows.slice(
        0,
        halfMonitoringCompleteAccess,
      );

      const rightMCARows = monitoringCompleteAccessRows.slice(
        halfMonitoringCompleteAccess,
      );

      const monitoringCompleteAccessHeader = [
        {
          text: 'REGIONE',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'left',
            fontSize: 7.5,
            color: this.brandInfoMedicine.colors.title,
          },
        },
        {
          text: 'MESI FORECAST',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: '00CEBC',
          },
        },
        {
          text: 'MESI ACTUAL',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: '141E58',
          },
        },
        {
          text: 'Δ',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: this.brandInfoMedicine.colors.title,
          },
        },
      ];
      this.leftMonitoringCompleteAccessTableRows = [
        monitoringCompleteAccessHeader,
        ...leftMCARows,
      ];

      this.rightMonitoringCompleteAccessTableRows = [
        monitoringCompleteAccessHeader,
        ...rightMCARows,
      ];
    } else {
      this.leftMonitoringCompleteAccessTableRows = [];
      this.rightMonitoringCompleteAccessTableRows = [];
    }

    // MONITORAGGIO AGGIUDICAZIONE GARA
    if (
      this.MonitoringAggiuducazioneGaraData &&
      this.MonitoringAggiuducazioneGaraData.length > 0
    ) {
      const monitoringAggiudicazioneRows =
        this.MonitoringAggiuducazioneGaraData.map((item) => {
          let deltaFill = 'FFFFFF';

          const delta = item.delta ?? 0;
          if (delta < 0) {
            deltaFill = 'CCF7DD';
          } else if (delta > 0) {
            deltaFill = 'FDE0E0';
          }

          let deltaText = delta > 0 ? `+${delta}` : `${delta}`;
          if (item.forecast == null || item.actual == null) {
            deltaText = '-';
            deltaFill = 'FFFFFF';
          }

          return [
            {
              text: this.formatRegionName(item.regionName ?? '-'),
              options: {
                align: 'left',
                fontSize: 6.5,
                fontFace: this.brandInfoMedicine.font.title,
              },
              color: '000000',
            },
            {
              text: item.forecast?.toString() ?? '-',
              options: {
                align: 'center',
                fontSize: 6.5,
                fontFace: this.brandInfoMedicine.font.title,
              },
              color: '000000',
            },
            {
              text: item.actual?.toString() ?? '-',
              options: {
                align: 'center',
                fontSize: 6.5,
                fontFace: this.brandInfoMedicine.font.title,
              },
              color: '000000',
            },
            {
              text: deltaText,
              options: {
                align: 'center',
                fontSize: 6.5,
                fontFace: this.brandInfoMedicine.font.title,
                fill: deltaFill,
              },
              color: '000000',
            },
          ];
        });

      const halfMonitoringAggiudicazione = Math.ceil(
        monitoringAggiudicazioneRows.length / 2,
      );
      const leftMARows = monitoringAggiudicazioneRows.slice(
        0,
        halfMonitoringAggiudicazione,
      );
      const rightMARows = monitoringAggiudicazioneRows.slice(
        halfMonitoringAggiudicazione,
      );

      const monitoringAggiudicazioneHeader = [
        {
          text: 'REGIONE',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'left',
            fontSize: 7.5,
            color: this.brandInfoMedicine.colors.title,
          },
        },
        {
          text: 'MESI FORECAST',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: '00CEBC',
          },
        },
        {
          text: 'MESI ACTUAL',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: '141E58',
          },
        },
        {
          text: 'Δ',
          options: {
            bold: true,
            fill: 'FFFFFF',
            align: 'center',
            fontSize: 7.5,
            color: this.brandInfoMedicine.colors.title,
          },
        },
      ];

      this.leftMonitoringAggiudicazioneTableRows = [
        monitoringAggiudicazioneHeader,
        ...leftMARows,
      ];

      this.rightMonitoringAggiudicazioneTableRows = [
        monitoringAggiudicazioneHeader,
        ...rightMARows,
      ];
    } else {
      this.leftMonitoringAggiudicazioneTableRows = [];
      this.rightMonitoringAggiudicazioneTableRows = [];
    }

    //////////////////////////////////////////////////////////////

    //Regional Access Widget
    /*this.regionalAccessTableData = this.regionalAccessData.map(item => {
      // Conditional background for Δ column
      let deltaFill = 'FFFFFF'; // default white

      if (this.compareDates(item.dueDate) < 0) {
        deltaFill = 'CCF7DD'; // light green
      } else if (this.compareDates(item.dueDate) > 0) {
        deltaFill = 'FDE0E0'; // light red
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            align: 'left',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: this.formatDate(item.dueDate.toString()),
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: this.compareDates(item.dueDate) + " GIORNI",
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            fill: deltaFill // <--- conditional background color
          },
          color: '000000'
        }
      ];
    });*/

    this.regionalAccessTableData = this.regionalAccessData.map((item) => {
      const dueDate = item.dueDate ?? null;
      const endDate = item.endDate ?? null;

      // Column 2: show dueDate (or '-')
      const dueDateText = dueDate ? this.formatDate(dueDate.toString()) : '-';

      // Column 3: delta logic
      let deltaFill = 'FFFFFF';
      let deltaText = '-';

      if (endDate) {
        // Completed: show endDate, always green background
        deltaFill = 'FFFFFF';
        deltaText = `Accesso:  ${this.formatDate(endDate.toString())}`;
      } else if (dueDate) {
        // Not completed: show days delta
        const deltaDays = this.compareDates(dueDate);
        deltaText =
          deltaDays > 0 ? `+${deltaDays} Giorni` : `${deltaDays} Giorni`;

        if (deltaDays < 0) {
          deltaFill = 'CCF7DD'; // green
        } else if (deltaDays > 0) {
          deltaFill = 'FDE0E0'; // red
        } else {
          deltaFill = 'FFFFFF'; // neutral
        }
      }

      return [
        {
          text: this.formatRegionName(item.regionName ?? '-'),
          options: {
            align: 'left',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
          },
          color: '000000',
        },
        {
          text: dueDateText,
          options: {
            align: 'center',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
          },
          color: '000000',
        },
        {
          text: deltaText,
          options: {
            align: 'center',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            fill: deltaFill,
          },
          color: '000000',
        },
      ];
    });

    const halfRegionalAccess = Math.ceil(this.regionalAccessData.length / 2);
    const leftRegionalAccessRows = this.regionalAccessTableData.slice(
      0,
      halfRegionalAccess,
    );
    const rightRegionalAccessRows =
      this.regionalAccessTableData.slice(halfRegionalAccess);

    this.leftRegionalAccessTableRows = [
      this.regionalAccessHeader,
      ...leftRegionalAccessRows,
    ];

    this.rightRegionalAccessTableRows = [
      this.regionalAccessHeader,
      ...rightRegionalAccessRows,
    ];

    //////////////////////////////////////////////////////////////
    // Forecast Accuracy Tables
    if (this.widgetsAvailable.some((w) => w.id === 17)) {
      this.forecastAccuracyOpenToAccessRows = this.buildForecastAccuracyRows(
        this.forecastAccuracyOpenToAccessData,
        false,
      );
    }

    if (this.widgetsAvailable.some((w) => w.id === 18)) {
      this.forecastAccuracyOpenToEconomiaRows = this.buildForecastAccuracyRows(
        this.forecastAccuracyOpenToEconomiaData,
        true,
      );
    }

    if (this.widgetsAvailable.some((w) => w.id === 19)) {
      this.forecastAccuracyOpenToMarketRows = this.buildForecastAccuracyRows(
        this.forecastAccuracyOpenToMarketData,
        true,
      );
    }

    //////////////////////////////////////////////////////////////
    // Inclusion Process Tool Tables (Processo di Inclusione)
    if (this.inclusionProcessData) {
      const ip = this.inclusionProcessData;

      // Start detail
      const startStatusLabel = this.getInclusionStatusLabel(
        ip.stepZero.status,
        ip.stepZero.dueDate,
      );
      const startStatusText =
        startStatusLabel +
        (ip.stepZero.status === 'COMPLETED' && ip.stepZero.endDate
          ? ` (${this.formatInclusionDate(ip.stepZero.endDate)})`
          : '');

      this.inclusionStartTableData = [
        this.inclusionStartHeader,
        [
          {
            text: 'Nazionale',
            options: {
              align: 'left',
              fontSize: 7,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: this.formatInclusionDate(ip.stepZero.dueDate),
            options: {
              align: 'center',
              fontSize: 7,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: startStatusText,
            options: {
              align: 'center',
              fontSize: 7,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: this.getInclusionStatusFillColor(startStatusLabel),
            },
          },
        ],
      ];

      // Inclusione Regionale detail (openToAccess)
      const regionaleRows = ip.openToAccess.map((row) => {
        const statusLabel = this.getInclusionStatusLabel(
          row.status,
          row.dueDate,
        );
        const statusText =
          statusLabel +
          (row.status === 'COMPLETED' && row.endDate
            ? ` (${this.formatInclusionDate(row.endDate)})`
            : '');
        return [
          {
            text: this.formatRegionName(row.regionName ?? '-'),
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: this.formatInclusionDate(row.dueDate),
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: statusText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: this.getInclusionStatusFillColor(statusLabel),
            },
          },
        ];
      });

      const halfRegionale = Math.ceil(regionaleRows.length / 2);
      this.leftInclusionRegionaleTableRows = [
        this.inclusionRegionHeader,
        ...regionaleRows.slice(0, halfRegionale),
      ];
      this.rightInclusionRegionaleTableRows = [
        this.inclusionRegionHeader,
        ...regionaleRows.slice(halfRegionale),
      ];

      // Aggiudicazione Gara detail
      const sortedAggiudicazione = [...ip.aggiudicazioneGara].sort((a, b) =>
        a.regionName.localeCompare(b.regionName),
      );
      const aggiudicazioneRows = sortedAggiudicazione.map((row) => {
        const statusLabel = this.getInclusionStatusLabel(
          row.status,
          row.dueDate,
        );
        const statusText =
          statusLabel +
          (row.status === 'COMPLETED' && row.endDate
            ? ` (${this.formatInclusionDate(row.endDate)})`
            : '');
        return [
          {
            text: this.formatRegionName(row.regionName ?? '-'),
            options: {
              align: 'left',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: this.formatInclusionDate(row.dueDate),
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
            },
          },
          {
            text: statusText,
            options: {
              align: 'center',
              fontSize: 6.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              fill: this.getInclusionStatusFillColor(statusLabel),
            },
          },
        ];
      });

      const halfAggiudicazione = Math.ceil(aggiudicazioneRows.length / 2);
      this.leftInclusionAggiudicazioneTableRows = [
        this.inclusionRegionHeader,
        ...aggiudicazioneRows.slice(0, halfAggiudicazione),
      ];
      this.rightInclusionAggiudicazioneTableRows = [
        this.inclusionRegionHeader,
        ...aggiudicazioneRows.slice(halfAggiudicazione),
      ];

      // Possibilità di Acquisto detail (openToMarket -> hospitals, flattened)
      const acquistoRows: any[] = [];
      [...ip.openToMarket]
        .sort((a, b) => a.regionName.localeCompare(b.regionName))
        .forEach((region) => {
          region.hospitals.forEach((hospital) => {
            const statusLabel = this.getInclusionStatusLabel(
              hospital.status,
              hospital.dueDate,
            );
            const statusText =
              statusLabel +
              (hospital.status === 'COMPLETED' && hospital.endDate
                ? ` (${this.formatInclusionDate(hospital.endDate)})`
                : '');
            acquistoRows.push([
              {
                text: this.formatRegionName(region.regionName ?? '-'),
                options: {
                  align: 'left',
                  fontSize: 6.5,
                  fontFace: this.brandInfoMedicine.font.title,
                  color: '000000',
                },
              },
              {
                text: hospital.name
                  ? `${hospital.name}${hospital.city ? ' - ' + hospital.city : ''}`
                  : (hospital.onekey ?? '-'),
                options: {
                  align: 'left',
                  fontSize: 6.5,
                  fontFace: this.brandInfoMedicine.font.title,
                  color: '000000',
                },
              },
              {
                text: this.formatInclusionDate(hospital.dueDate),
                options: {
                  align: 'center',
                  fontSize: 6.5,
                  fontFace: this.brandInfoMedicine.font.title,
                  color: '000000',
                },
              },
              {
                text: statusText,
                options: {
                  align: 'center',
                  fontSize: 6.5,
                  fontFace: this.brandInfoMedicine.font.title,
                  color: '000000',
                  fill: this.getInclusionStatusFillColor(statusLabel),
                },
              },
            ]);
          });
        });

      this.inclusionAcquistoTableRows = acquistoRows;
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  //Generate PPT
  async generatePPT(): Promise<void> {
    const pptx = new PptxGenJS();

    const slide1 = pptx.addSlide();
    //slide1.background = { path: './assets/img/bg_report.png' };

    // ribbons decoration, colored with the report primary and secondary colors
    slide1.addImage({
      data: this.getCoverRibbonsSvg(
        this.brandInfoMedicine.colors.title,
        this.brandInfoMedicine.colors.subtitle,
      ),
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
    });

    //Logo medicine
    slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 0.5,
      y: 0.4,
      w: '8%',
      h: '10%',
    });

    //company logo
    /*slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.7,
      y: 0.4,
      w: '8%',
      h: '10%'
    });*/

    /*slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 4.2,
      y: 0.7,
      w: '13%',
      h: '10%'
    });*/

    slide1.addText('Nazione', {
      x: 1.2,
      y: 1.9,
      h: '10%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000',
      bold: true,
      align: 'center',
    });

    // Add the title (Farmaco 2)
    slide1.addText(this.medicineName, {
      x: 1.2,
      y: 2.2,
      h: '40%',
      fontSize: 40,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'center',
    });

    const slide2 = pptx.addSlide();
    slide2.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide2.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%',
    });

    //company logo
    /*slide2.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide2.addText('Informazioni Prodotto', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 14,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide2.addText('Dettagli e caratteristiche principali', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 9.5,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    //@ts-ignore
    if (this.medicineTableData && this.medicineTableData.length > 0) {
      slide2.addTable(this.medicineTableData, {
        fill: { color: 'FFFFFF' },
        x: 0.5,
        y: 1.5,
        w: '90%',
        rowH: 0.5,
        valign: 'middle',
        bold: false,
        fontSize: 7.5,
        color: '204131',
        border: { pt: 1.25, color: 'F1F1F1' },
      });
    }

    if (
      this.medicineTherapeuticInfoTableData &&
      this.medicineTherapeuticInfoTableData.length > 0
    ) {
      slide2.addTable(this.medicineTherapeuticInfoTableData, {
        fill: { color: 'FFFFFF' },
        x: 0.5,
        y: 2.8,
        w: '90%',
        rowH: 0.5,
        valign: 'middle',
        bold: false,
        fontSize: 7.5,
        color: '204131',
        border: { pt: 1.25, color: 'F1F1F1' },
      });
    }

    // espeirenze and hospitals
    if (
      this.totalNumbersExperienceAndHospitalsTable &&
      this.totalNumbersExperienceAndHospitalsTable.length > 0
    ) {
      slide2.addTable(this.totalNumbersExperienceAndHospitalsTable, {
        fill: { color: 'FFFFFF' },
        x: 0.5,
        y: 4.15,
        w: '90%',
        colW: 2,
        rowH: 0.5,
        valign: 'middle',
        bold: false,
        fontSize: 7.5,
        color: '204131',
        border: { pt: 1.25, color: 'F1F1F1' },
      });
    }

    // SLIDE 3 - widget-esperienze-map (id: 0)
    if (this.widgetsAvailable.some((widget) => widget.id === 0)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 0)?.name;
      const slide3 = pptx.addSlide();
      slide3.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide3.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slide3.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide3.addText(TOOLTIPS_NT.find((t) => t.id === 0)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.9, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      slide3.addImage({
        // data: this.experienceMapBase64String, // Base64 image from the service
        path: './assets/img/widgetsPreview/esperienzeMap.png',
        x: 0.78,
        y: 1.3,
        w: '30.1%', //45% with the data
        h: '71.5%', // 65% with the data
      });

      const leftTable = this.leftExpMapTableRows.map((row) =>
        row.map((cell: any) => {
          const n = Number(cell);
          if (!isNaN(n)) {
            return n.toFixed(2);
          }
          return cell;
        }),
      );

      const rightTable = this.rightExpMapTableRows.map((row) =>
        row.map((cell: any) => {
          const n = Number(cell);
          if (!isNaN(n)) {
            return n.toFixed(2);
          }
          return cell;
        }),
      );

      // @ts-ignore
      if (leftTable && leftTable.length > 0) {
        slide3.addTable(leftTable, {
          fill: { color: 'FFFFFF' },
          x: 4.2,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (rightTable && rightTable.length > 0) {
        slide3.addTable(rightTable, {
          fill: { color: 'FFFFFF' },
          x: 7.0,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    }

    // SLIDE 4 - widget-mapOpenAccess (id: 5)
    if (this.widgetsAvailable.some((widget) => widget.id === 5)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 5)?.name;

      const slide4 = pptx.addSlide();
      slide4.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide4.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /* slide4.addImage({
       path: this.brandInfoMedicine.logo.url,
       x: 9.2,
       y: 5,
       w: '4%',
       h: '6%'
     });*/

      if (widgetName) {
        slide4.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }
      slide4.addText(TOOLTIPS_NT.find((t) => t.id === 5)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.9, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      slide4.addImage({
        data: this.regAccessMapBase64String, // Base64 image from the service
        x: 0.2,
        y: 1.5,
        w: '45%',
        h: '65%',
      });

      // Red square (Chiusura)
      slide4.addShape(pptx.ShapeType.roundRect, {
        x: 2.8,
        y: 5.0,
        w: 0.08,
        h: 0.08,
        fill: {
          color:
            this.heatmapRegionalInclusionColor === 'Red' ? 'C10007' : 'FFFFFF',
        },
        line: {
          color:
            this.heatmapRegionalInclusionColor === 'White'
              ? '162456'
              : 'C10007',
          width: 0.5,
        },
      });

      slide4.addText('Chiusura', {
        x: 2.8 + 0.03, // a bit to the right of the square
        y: 5.0 + 0.03,
        fontSize: 8,
        color: '000000',
        bold: false,
      });

      // Green square (Apertura)
      slide4.addShape(pptx.ShapeType.roundRect, {
        x: 1.5,
        y: 5.0,
        w: 0.08,
        h: 0.08,
        fill: { color: '008236' }, // green
        line: { color: '008236' },
      });

      slide4.addText('Apertura', {
        x: 1.5 + 0.03,
        y: 5.0 + 0.03,
        fontSize: 8,
        color: '000000',
        bold: false,
      });

      slide4.addText(
        [
          {
            text: 'Commenti:',
            options: {
              bold: true,
              color: this.brandInfoMedicine.colors.subtitle, // green
              fontSize: 11,
            },
          },
          {
            text: '\nQui puoi scrivere i tuoi commenti.',
            options: {
              italic: true,
              color: '404040', // dark grey
              fontSize: 9,
            },
          },
        ],
        {
          x: 4.2, // Slightly from the left edge
          y: 1.5, // Slightly from the top edge
          w: '50%', // Full slide width
          h: '50%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: '000000', //color:'000000', // Aqua color
          bold: false,
          align: 'left',
          valign: 'top',
        },
      );
    }

    // SLIDE 5 - widget (id: 15) - heatmap-economia
    if (this.widgetsAvailable.some((widget) => widget.id === 15)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 15)?.name;
      const slide5 = pptx.addSlide();
      slide5.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });
      slide5.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      if (widgetName) {
        slide5.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }
      slide5.addText(TOOLTIPS_NT.find((t) => t.id === 15)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });
      slide5.addImage({
        data: this.heatmapEconomiaBase64String,
        x: 0.2,
        y: 1.5,
        w: '45%',
        h: '65%',
      });
      slide5.addImage({
        path:
          this.heatmapEconomiaColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.0 + 0.04,
        w: '27%',
        h: '5%',
      });
      //@ts-ignore
      if (
        this.leftHeatmapInEconomiaTableRows &&
        this.leftHeatmapInEconomiaTableRows.length > 0
      ) {
        slide5.addTable(this.leftHeatmapInEconomiaTableRows, {
          fill: { color: 'FFFFFF' },
          x: 4.2,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
      if (
        this.rightHeatmapInEconomiaTableRows &&
        this.rightHeatmapInEconomiaTableRows.length > 0
      ) {
        slide5.addTable(this.rightHeatmapInEconomiaTableRows, {
          fill: { color: 'FFFFFF' },
          x: 7.0,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // SLIDE 5b - heatmap-economia con percentuali
      const slide5b = pptx.addSlide();
      slide5b.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });
      slide5b.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      if (widgetName) {
        slide5b.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }
      slide5b.addText(TOOLTIPS_NT.find((t) => t.id === 15)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      const legendX = 0.558;
      const legendY = 1.2;
      slide5b.addText('*', {
        x: legendX,
        y: legendY + 0.05,
        w: 0.1,
        h: 0.2,
        fontSize: 7.5,
        color: 'FF0000',
        bold: true,
        align: 'left',
        valign: 'middle',
      });
      slide5b.addText(
        'I valori indicati rappresentano le percentuali di apertura.',
        {
          x: legendX + 0.02,
          y: legendY,
          w: 8,
          h: 0.3,
          fontSize: 7,
          fontFace: this.brandInfoMedicine.font.title,
          color: '000000',
          bold: false,
          align: 'left',
          valign: 'middle',
        },
      );

      slide5b.addImage({
        data: this.heatmapEconomiaBase64String,
        x: 0.2,
        y: 1.6,
        w: '45%',
        h: '65%',
      });
      slide5b.addImage({
        path:
          this.heatmapEconomiaColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.1 + 0.04,
        w: '27%',
        h: '5%',
      });

      interface RegionCoordinates {
        [key: string]: { x: number; y: number };
      }
      const regionCoordinates: RegionCoordinates = {
        Lombardia: { x: 1.74, y: 2.2 },
        Piemonte: { x: 1.35, y: 2.3 },
        "Valle D'Aosta": { x: 1.16, y: 2.05 },
        Liguria: { x: 1.5, y: 2.55 },
        'Friuli Venezia Giulia': { x: 2.43, y: 1.98 },
        Veneto: { x: 2.1, y: 2.14 },
        'Prov. Aut. di Bolzano': { x: 2.1, y: 1.7 },
        'Prov. Aut. di Trento': { x: 1.96, y: 1.98 },
        'Emilia-Romagna': { x: 1.99, y: 2.47 },
        Toscana: { x: 1.93, y: 2.75 },
        Marche: { x: 2.54, y: 2.79 },
        Umbria: { x: 2.3, y: 2.95 },
        Lazio: { x: 2.31, y: 3.26 },
        Abruzzo: { x: 2.67, y: 3.1 },
        Molise: { x: 2.83, y: 3.33 },
        Campania: { x: 2.78, y: 3.6 },
        Puglia: { x: 3.22, y: 3.45 },
        Calabria: { x: 3.075, y: 4.03 },
        Basilicata: { x: 3.08, y: 3.68 },
        Sicilia: { x: 2.7, y: 4.46 },
        Sardegna: { x: 1.48, y: 3.8 },
      };

      this.heatmapInEconomiaData.forEach((item) => {
        if (!item.inEconomia) return;

        const coords = regionCoordinates[item.regionName];
        if (
          coords &&
          item.percentage !== undefined &&
          item.percentage !== null
        ) {
          const p = Number(item.percentage);
          if (!isNaN(p) && p !== 0) {
            slide5b.addText(item.percentage, {
              x: coords.x,
              y: coords.y,
              w: 0.22,
              h: 0.1,
              fontSize: 4.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              bold: true,
              align: 'center',
              valign: 'middle',
              fill: { color: 'FFFFFF' },
              margin: 0,
              wrap: false,
            });
          }
        }
      });

      slide5b.addText(
        [
          {
            text: 'Commenti:',
            options: {
              bold: true,
              color: this.brandInfoMedicine.colors.subtitle,
              fontSize: 11,
            },
          },
          {
            text: '\nQui puoi scrivere i tuoi commenti.',
            options: { italic: true, color: '404040', fontSize: 9 },
          },
        ],
        {
          x: 4.6,
          y: 1.6,
          w: '50%',
          h: '50%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
          valign: 'top',
        },
      );

      // SLIDE 5c - Heatmap Apertura in Economia Merged (table) - all regions, inEconomia flag ignored
      const mergedTitle = 'Heatmap Apertura in Economia Merged';
      const mergedSubtitle =
        "In questa Merged Heatmap mostriamo i risultati di Apertura in Economia, con l'aggiunta dei risultati di Apertura Ospedaliera per le cinque regioni italiane in cui la possibilità di acquisto in economia non è possibile: Valle d'Aosta, Piemonte, Toscana, Lazio e Sicilia.";

      const slideMergedTable = pptx.addSlide();
      slideMergedTable.addText(
        this.medicineName.toUpperCase() || 'NOME FARMACO',
        {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        },
      );
      slideMergedTable.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      slideMergedTable.addText(mergedTitle, {
        x: 0.5,
        y: 0.6,
        w: '70%',
        h: '8%',
        fontSize: 14,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: this.brandInfoMedicine.colors.subtitle,
        bold: true,
        align: 'left',
      });
      slideMergedTable.addText(mergedSubtitle, {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });
      slideMergedTable.addImage({
        data: this.heatmapMergedBase64String,
        x: 0.2,
        y: 1.5,
        w: '45%',
        h: '65%',
      });
      slideMergedTable.addImage({
        path:
          this.heatmapEconomiaColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.0 + 0.04,
        w: '27%',
        h: '5%',
      });
      //@ts-ignore
      if (
        this.leftHeatmapMergedTableRows &&
        this.leftHeatmapMergedTableRows.length > 0
      ) {
        slideMergedTable.addTable(this.leftHeatmapMergedTableRows, {
          fill: { color: 'FFFFFF' },
          x: 4.2,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
      if (
        this.rightHeatmapMergedTableRows &&
        this.rightHeatmapMergedTableRows.length > 0
      ) {
        slideMergedTable.addTable(this.rightHeatmapMergedTableRows, {
          fill: { color: 'FFFFFF' },
          x: 7.0,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // SLIDE 5d - Heatmap Apertura in Economia Merged (percentuali sulla mappa) - all regions, inEconomia flag ignored
      const slideMerged = pptx.addSlide();
      slideMerged.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });
      slideMerged.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      slideMerged.addText(mergedTitle, {
        x: 0.5,
        y: 0.6,
        w: '70%',
        h: '8%',
        fontSize: 14,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: this.brandInfoMedicine.colors.subtitle,
        bold: true,
        align: 'left',
      });
      slideMerged.addText(mergedSubtitle, {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      slideMerged.addImage({
        data: this.heatmapMergedBase64String,
        x: 0.2,
        y: 1.6,
        w: '45%',
        h: '65%',
      });
      slideMerged.addImage({
        path:
          this.heatmapEconomiaColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.1 + 0.04,
        w: '27%',
        h: '5%',
      });

      this.heatmapInEconomiaData.forEach((item) => {
        const coords = regionCoordinates[item.regionName];
        if (
          coords &&
          item.percentage !== undefined &&
          item.percentage !== null
        ) {
          const p = Number(item.percentage);
          if (!isNaN(p) && p !== 0) {
            slideMerged.addText(item.percentage, {
              x: coords.x,
              y: coords.y,
              w: 0.22,
              h: 0.1,
              fontSize: 4.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              bold: true,
              align: 'center',
              valign: 'middle',
              fill: { color: 'FFFFFF' },
              margin: 0,
              wrap: false,
            });
          }
        }
      });

      slideMerged.addText(
        [
          {
            text: 'Commenti:',
            options: {
              bold: true,
              color: this.brandInfoMedicine.colors.subtitle,
              fontSize: 11,
            },
          },
          {
            text: '\nQui puoi scrivere i tuoi commenti.',
            options: { italic: true, color: '404040', fontSize: 9 },
          },
        ],
        {
          x: 4.6,
          y: 1.6,
          w: '50%',
          h: '50%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
          valign: 'top',
        },
      );
    }

    // SLIDE 5c - widget-heatmap (id: 1)
    if (this.widgetsAvailable.some((widget) => widget.id === 1)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 1)?.name;
      const slide5c = pptx.addSlide();
      slide5c.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });
      slide5c.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      if (widgetName) {
        slide5c.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }
      slide5c.addText(TOOLTIPS_NT.find((t) => t.id === 1)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });
      slide5c.addImage({
        data: this.heatmapBase64String,
        x: 0.2,
        y: 1.5,
        w: '45%',
        h: '65%',
      });
      slide5c.addImage({
        path:
          this.heatmapColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.0 + 0.04,
        w: '27%',
        h: '5%',
      });
      //@ts-ignore
      if (this.leftHeatmapTableRows && this.leftHeatmapTableRows.length > 0) {
        slide5c.addTable(this.leftHeatmapTableRows, {
          fill: { color: 'FFFFFF' },
          x: 4.2,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
      if (this.rightHeatmapTableRows && this.rightHeatmapTableRows.length > 0) {
        slide5c.addTable(this.rightHeatmapTableRows, {
          fill: { color: 'FFFFFF' },
          x: 7.0,
          y: 1.5,
          colW: [1.5, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // SLIDE 5d - heatmap originale con percentuali
      const slide5d = pptx.addSlide();
      slide5d.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });
      slide5d.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });
      if (widgetName) {
        slide5d.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }
      slide5d.addText(TOOLTIPS_NT.find((t) => t.id === 1)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      const legendX5d = 0.558;
      const legendY5d = 1.2;
      slide5d.addText('*', {
        x: legendX5d,
        y: legendY5d + 0.05,
        w: 0.1,
        h: 0.2,
        fontSize: 7.5,
        color: 'FF0000',
        bold: true,
        align: 'left',
        valign: 'middle',
      });
      slide5d.addText(
        'I valori indicati rappresentano le percentuali di apertura.',
        {
          x: legendX5d + 0.02,
          y: legendY5d,
          w: 8,
          h: 0.3,
          fontSize: 7,
          fontFace: this.brandInfoMedicine.font.title,
          color: '000000',
          bold: false,
          align: 'left',
          valign: 'middle',
        },
      );

      slide5d.addImage({
        data: this.heatmapBase64String,
        x: 0.2,
        y: 1.6,
        w: '45%',
        h: '65%',
      });
      slide5d.addImage({
        path:
          this.heatmapColor === 'White'
            ? './assets/img/heatmapBarWhite.png'
            : './assets/img/heatmapBar.png',
        x: 1.2,
        y: 5.1 + 0.04,
        w: '27%',
        h: '5%',
      });

      interface RegionCoordinates5d {
        [key: string]: { x: number; y: number };
      }
      const regionCoordinates5d: RegionCoordinates5d = {
        Lombardia: { x: 1.74, y: 2.2 },
        Piemonte: { x: 1.35, y: 2.3 },
        "Valle D'Aosta": { x: 1.16, y: 2.05 },
        Liguria: { x: 1.5, y: 2.55 },
        'Friuli Venezia Giulia': { x: 2.43, y: 1.98 },
        Veneto: { x: 2.1, y: 2.14 },
        'Prov. Aut. di Bolzano': { x: 2.1, y: 1.7 },
        'Prov. Aut. di Trento': { x: 1.96, y: 1.98 },
        'Emilia-Romagna': { x: 1.99, y: 2.47 },
        Toscana: { x: 1.93, y: 2.75 },
        Marche: { x: 2.54, y: 2.79 },
        Umbria: { x: 2.3, y: 2.95 },
        Lazio: { x: 2.31, y: 3.26 },
        Abruzzo: { x: 2.67, y: 3.1 },
        Molise: { x: 2.83, y: 3.33 },
        Campania: { x: 2.78, y: 3.6 },
        Puglia: { x: 3.22, y: 3.45 },
        Calabria: { x: 3.075, y: 4.03 },
        Basilicata: { x: 3.08, y: 3.68 },
        Sicilia: { x: 2.7, y: 4.46 },
        Sardegna: { x: 1.48, y: 3.8 },
      };

      this.heatmapData.forEach((item) => {
        const coords = regionCoordinates5d[item.regionName];
        if (
          coords &&
          item.percentage !== undefined &&
          item.percentage !== null
        ) {
          const p = Number(item.percentage);
          if (!isNaN(p) && p !== 0) {
            slide5d.addText(item.percentage, {
              x: coords.x,
              y: coords.y,
              w: 0.22,
              h: 0.1,
              fontSize: 4.5,
              fontFace: this.brandInfoMedicine.font.title,
              color: '000000',
              bold: true,
              align: 'center',
              valign: 'middle',
              fill: { color: 'FFFFFF' },
              margin: 0,
              wrap: false,
            });
          }
        }
      });

      slide5d.addText(
        [
          {
            text: 'Commenti:',
            options: {
              bold: true,
              color: this.brandInfoMedicine.colors.subtitle,
              fontSize: 11,
            },
          },
          {
            text: '\nQui puoi scrivere i tuoi commenti.',
            options: { italic: true, color: '404040', fontSize: 9 },
          },
        ],
        {
          x: 4.6,
          y: 1.6,
          w: '50%',
          h: '50%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
          valign: 'top',
        },
      );
    }
    // SLIDE 6 - widget-attivita (id: 2)
    if (this.widgetsAvailable.some((widget) => widget.id === 2)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 2)?.name;
      const tooltipText = TOOLTIPS_NT.find((t) => t.id === 2)?.text || '';

      const activityColWidths = [2.8, 0.35, 2.1, 0.85, 0.85, 0.85, 0.9];
      const tableStartY = 1.32;
      const maxTableBottomY = 5.35;
      const headerRowH = 0.35;

      const addActivitySlide = (rows: any[][], isFirstPage: boolean) => {
        const slide = pptx.addSlide();
        slide.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        });
        slide.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });
        if (widgetName) {
          slide.addText(widgetName, {
            x: 0.5,
            y: 0.6,
            w: '70%',
            h: '8%',
            fontSize: 14,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: this.brandInfoMedicine.colors.subtitle,
            bold: true,
            align: 'left',
          });
        }
        if (isFirstPage) {
          slide.addText(tooltipText, {
            x: 0.5,
            y: 0.9,
            w: '93%',
            h: '8%',
            fontSize: 9.5,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
          });
        }
        // @ts-ignore
        slide.addTable([this.activitySummaryHeader, ...rows], {
          fill: { color: 'FFFFFF' },
          x: 0.5,
          y: tableStartY,
          colW: activityColWidths,
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      };

      // estimate wrapped height of a row based on its longest cell
      const estimateRowHeight = (row: any[], fontSize = 7.5): number => {
        // 72 = 1 inch
        const avgCharWidthIn = (fontSize * 0.5) / 72;
        const lineHeightIn = (fontSize * 1.2) / 72;

        let maxLines = 1;
        row.forEach((cell, idx) => {
          const text = (cell?.text ?? '').toString();
          const colWidthIn = activityColWidths[idx] ?? 1;
          const usableWidthIn = Math.max(0.3, colWidthIn - 0.1);
          const charsPerLine = Math.max(
            1,
            Math.floor(usableWidthIn / avgCharWidthIn),
          );

          const linesForCell = text
            .split('\n')
            .reduce(
              (acc: number, p: string) =>
                acc + Math.max(1, Math.ceil(p.length / charsPerLine)),
              0,
            );

          if (linesForCell > maxLines) maxLines = linesForCell;
        });

        return Math.max(0.3, maxLines * lineHeightIn + 0.08);
      };

      if (this.activitySummaryTableRows.length > 0) {
        let currentPageRows: any[][] = [];
        let currentHeight = headerRowH;
        let isFirst = true;

        this.activitySummaryTableRows.forEach((row) => {
          const rowHeight = estimateRowHeight(row);

          if (
            currentPageRows.length > 0 &&
            tableStartY + currentHeight + rowHeight > maxTableBottomY
          ) {
            addActivitySlide(currentPageRows, isFirst);
            isFirst = false;
            currentPageRows = [];
            currentHeight = headerRowH;
          }

          currentPageRows.push(row);
          currentHeight += rowHeight;
        });

        if (currentPageRows.length > 0) {
          addActivitySlide(currentPageRows, isFirst);
        }
      } else {
        addActivitySlide([], true);
      }
    }

    // SLIDE 7 - widget-evolution-regional-access (id: 6)
    if (this.widgetsAvailable.some((widget) => widget.id === 6)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 6)?.name;
      const slide7 = pptx.addSlide();
      slide7.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide7.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /* slide7.addImage({
       path: this.brandInfoMedicine.logo.url,
       x: 9.2,
       y: 5,
       w: '4%',
       h: '6%'
     });*/

      if (widgetName) {
        slide7.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide7.addText(TOOLTIPS_NT.find((t) => t.id === 6)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.9, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      const totalMonths = this.regionalAccessEvolutionTableData[0].length - 1;

      const maxCols = totalMonths > 12 ? 7 : 6;
      const colWidth = totalMonths > 12 ? 1.12 : 1.28;

      if (this.regionalAccessEvolutionTableData?.length > 0) {
        const tables = this.splitTableByColumns(
          this.regionalAccessEvolutionTableData,
          maxCols,
        );

        tables.forEach((table, index) => {
          let lift = 0;
          if (totalMonths > 14) {
            if (index === 0) {
              lift = 0.01;
            } else if (index === 1) {
              lift = 0.62;
            } else {
              lift = 1.25;
            }
          }

          slide7.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.4 + index * 2 - lift,
            colW: Array(table[0].length).fill(colWidth),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }
      if (this.regionalAccessEvolutionTableDataActual?.length > 0) {
        const tablesActual = this.splitTableByColumns(
          this.regionalAccessEvolutionTableDataActual,
          maxCols,
        );

        tablesActual.forEach((table, index) => {
          slide7.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.7 + index * 2,
            colW: Array(table[0].length).fill(colWidth),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }
    }
    // SLIDE 7-economia - widget-evolution-regional-economia (id: 20)
    if (this.widgetsAvailable.some((w) => w.id === 20)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 20)?.name;
      const slide7economia = pptx.addSlide();

      // Titolo farmaco
      slide7economia.addText(
        this.medicineName.toUpperCase() || 'NOME FARMACO',
        {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        },
      );

      // Logo
      slide7economia.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      // Nome widget
      if (widgetName) {
        slide7economia.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }

      // Descrizione
      slide7economia.addText(TOOLTIPS_NT.find((t) => t.id === 20)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      const totalMonthsForecastEconomia =
        this.regionalEconomiaEvolutionTableDataForecast?.[0]?.length - 1 || 0;
      const totalMonthsActualEconomia =
        this.regionalEconomiaEvolutionTableDataActual?.[0]?.length - 1 || 0;

      const maxColsForecastEconomia = totalMonthsForecastEconomia > 12 ? 7 : 6;
      const colWidthForecastEconomia =
        totalMonthsForecastEconomia > 12 ? 1.12 : 1.28;

      const maxColsActualEconomia = totalMonthsActualEconomia > 12 ? 7 : 6;
      const colWidthActualEconomia =
        totalMonthsActualEconomia > 12 ? 1.12 : 1.28;

      if (this.regionalEconomiaEvolutionTableDataForecast?.length > 0) {
        const tablesForecastEconomia = this.splitTableByColumns(
          this.regionalEconomiaEvolutionTableDataForecast,
          maxColsForecastEconomia,
        );

        tablesForecastEconomia.forEach((table, index) => {
          let lift = 0;
          if (totalMonthsForecastEconomia > 14) {
            if (index === 0) {
              lift = 0.01;
            } else if (index === 1) {
              lift = 0.62;
            } else {
              lift = 1.25;
            }
          }

          slide7economia.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.4 + index * 2 - lift,
            colW: Array(table[0].length).fill(colWidthForecastEconomia),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }

      // Tabelle actual divise
      if (this.regionalEconomiaEvolutionTableDataActual?.length > 0) {
        const tablesActualEconomia = this.splitTableByColumns(
          this.regionalEconomiaEvolutionTableDataActual,
          maxColsActualEconomia,
        );

        tablesActualEconomia.forEach((table, index) => {
          slide7economia.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.7 + index * 2,
            colW: Array(table[0].length).fill(colWidthActualEconomia),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }
    }
    // SLIDE 7b - widget-evolution-regional-market (id: 10)
    if (this.widgetsAvailable.some((w) => w.id === 10)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 10)?.name;
      const slide7b = pptx.addSlide();

      // Titolo farmaco
      slide7b.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });

      // Logo
      slide7b.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      // Nome widget
      if (widgetName) {
        slide7b.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }

      // Descrizione
      slide7b.addText(TOOLTIPS_NT.find((t) => t.id === 10)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      const totalMonthsForecast =
        this.regionalMarketEvolutionTableDataForecast?.[0]?.length - 1 || 0;
      const totalMonthsActual =
        this.regionalMarketEvolutionTableDataActual?.[0]?.length - 1 || 0;

      const maxColsForecast = totalMonthsForecast > 12 ? 7 : 6;
      const colWidthForecast = totalMonthsForecast > 12 ? 1.12 : 1.28;

      const maxColsActual = totalMonthsActual > 12 ? 7 : 6;
      const colWidthActual = totalMonthsActual > 12 ? 1.12 : 1.28;

      if (this.regionalMarketEvolutionTableDataForecast?.length > 0) {
        const tablesForecast = this.splitTableByColumns(
          this.regionalMarketEvolutionTableDataForecast,
          maxColsForecast,
        );

        tablesForecast.forEach((table, index) => {
          let lift = 0;
          if (totalMonthsForecast > 14) {
            if (index === 0) {
              lift = 0.01;
            } else if (index === 1) {
              lift = 0.62;
            } else {
              lift = 1.25;
            }
          }

          slide7b.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.4 + index * 2 - lift,
            colW: Array(table[0].length).fill(colWidthForecast),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }

      // Tabelle actual divise
      if (this.regionalMarketEvolutionTableDataActual?.length > 0) {
        const tablesActual = this.splitTableByColumns(
          this.regionalMarketEvolutionTableDataActual,
          maxColsActual,
        );

        tablesActual.forEach((table, index) => {
          slide7b.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.7 + index * 2,
            colW: Array(table[0].length).fill(colWidthActual),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }
    }
    //
    // SLIDE 7c - widget-evolution-regional-market (id: 22)
    if (this.widgetsAvailable.some((w) => w.id === 22)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 22)?.name;
      const slide7c = pptx.addSlide();

      // Titolo farmaco
      slide7c.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });

      // Logo
      slide7c.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      // Nome widget
      if (widgetName) {
        slide7c.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }

      // Descrizione
      slide7c.addText(TOOLTIPS_NT.find((t) => t.id === 10)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      const totalMonthsForecast =
        this.regionalMarket30DaysEvolutionTableDataForecast?.[0]?.length - 1 ||
        0;
      const totalMonthsActual =
        this.regionalMarket30DaysEvolutionTableDataActual?.[0]?.length - 1 || 0;

      const maxColsForecast = totalMonthsForecast > 12 ? 7 : 6;
      const colWidthForecast = totalMonthsForecast > 12 ? 1.12 : 1.28;

      const maxColsActual = totalMonthsActual > 12 ? 7 : 6;
      const colWidthActual = totalMonthsActual > 12 ? 1.12 : 1.28;

      if (this.regionalMarket30DaysEvolutionTableDataForecast?.length > 0) {
        const tablesForecast = this.splitTableByColumns(
          this.regionalMarket30DaysEvolutionTableDataForecast,
          maxColsForecast,
        );

        tablesForecast.forEach((table, index) => {
          let lift = 0;
          if (totalMonthsForecast > 14) {
            if (index === 0) {
              lift = 0.01;
            } else if (index === 1) {
              lift = 0.62;
            } else {
              lift = 1.25;
            }
          }

          slide7c.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.4 + index * 2 - lift,
            colW: Array(table[0].length).fill(colWidthForecast),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }

      // Tabelle actual divise
      if (this.regionalMarket30DaysEvolutionTableDataActual?.length > 0) {
        const tablesActual = this.splitTableByColumns(
          this.regionalMarket30DaysEvolutionTableDataActual,
          maxColsActual,
        );

        tablesActual.forEach((table, index) => {
          slide7c.addTable(table, {
            fill: { color: 'FFFFFF' },
            x: 0.5,
            y: 1.7 + index * 2,
            colW: Array(table[0].length).fill(colWidthActual),
            h: 1.1,
            valign: 'middle',
            fontSize: 10,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        });
      }
    }
    //

    // SLIDE 8 - widget-curva-accesso (id: 3)
    if (
      this.widgetsAvailable.some((widget) => widget.id === 3) &&
      this.openToAccessLabels.length > 0
    ) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 3)?.name;

      const slide8 = pptx.addSlide();
      slide8.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide8.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slide8.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slide8.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide8.addText(TOOLTIPS_NT.find((t) => t.id === 3)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 1, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      this.addCurveLegend(pptx, slide8, 1.95, 4.63);

      slide8.addChart(
        pptx.ChartType.line,
        [
          {
            name: 'Forecast',
            labels: this.openToAccessLabels,
            values: this.openToAccessTargetData,
            line: { color: '#00CEBC' },
          },
          {
            name: 'Actual',
            labels: this.openToAccessLabels,
            values: this.openToAccessActualData,
            line: { color: '#141F58' },
          },
        ],
        {
          x: 0.5,
          y: 1.68,
          w: 4.2,
          h: 2.75,

          // --- Legend ---
          showLegend: false,

          // --- Lines & markers ---
          lineSize: 1.5,
          lineDataSymbol: 'circle',
          lineDataSymbolSize: 4,
          lineDataSymbolLineSize: 0, // no outline

          // --- Values / labels on points ---
          showValue: false,

          // --- Y axis (0–100%, step 10) ---
          valAxisMinVal: 0,
          valAxisMaxVal: 105,
          valAxisMajorUnit: 10,
          valAxisLabelFormatCode: '0"%"', // 0%, 10%, 20%, ...
          valAxisLabelFontFace: this.brandInfoMedicine.font.title,
          valAxisLabelFontSize: 5,
          valAxisLabelColor: '555555',
          valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

          // --- X axis (dates, rotated) ---
          catAxisLabelFontFace: this.brandInfoMedicine.font.title,
          catAxisLabelFontSize: 5,
          catAxisLabelColor: '555555',
          catAxisLabelRotate: 0,
          catAxisLineShow: false,
          catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

          // --- General ---
          plotArea: { fill: { color: 'FFFFFF' } },
          chartArea: {
            fill: { color: 'FFFFFF' },
            border: { pt: 0, color: 'FFFFFF' },
          },
          chartColors: ['#00CEBC', '#141F58'],
          showTitle: false,
        },
      );

      //@ts-ignore
      if (this.openToAccessTableData && this.openToAccessTableData.length > 0) {
        slide8.addTable(this.openToAccessTableData, {
          fill: { color: 'FFFFFF' },
          x: 5.5,
          y: 1.75,
          colW: 1.0,
          rowH: 0.2,
          valign: 'middle',
          bold: false,
          fontSize: 6.5,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // SLIDE 9
      if (
        this.widgetsAvailable.some((widget) => widget.id === 3) &&
        this.openToAccessLabels.length > 0
      ) {
        const widgetName = this.widgetsAvailable.find((w) => w.id === 3)?.name;

        // find the last index where actual data is not null or undefined
        let lastActualIndex = -1;
        for (let i = this.openToAccessLabels.length - 1; i >= 0; i--) {
          if (
            this.openToAccessActualData[i] !== null &&
            this.openToAccessActualData[i] !== undefined
          ) {
            lastActualIndex = i;
            break;
          }
        }

        const actualValuesTruncated =
          lastActualIndex >= 0
            ? this.openToAccessActualData.slice(0, lastActualIndex + 1)
            : [];

        const slide9 = pptx.addSlide();

        slide9.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        });

        // Logo
        slide9.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });

        if (widgetName) {
          slide9.addText(widgetName, {
            x: 0.5,
            y: 0.6,
            w: '70%',
            h: '8%',
            fontSize: 14,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: this.brandInfoMedicine.colors.subtitle,
            bold: true,
            align: 'left',
          });
        }

        slide9.addText(TOOLTIPS_NT.find((t) => t.id === 3)?.text || '', {
          x: 0.5,
          y: 1.0,
          w: '93%',
          h: '8%',
          fontSize: 9.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
        });

        // graph
        this.addCurveLegend(pptx, slide9, 2.57, 4.99);

        slide9.addChart(
          this.buildCurveChartTypes(
            pptx,
            this.openToAccessLabels,
            this.openToAccessTargetData,
            actualValuesTruncated,
          ),
          {
            x: 0.5,
            y: 1.58,
            w: 5.45,
            h: 3.25,

            showLegend: false,

            lineSize: 1.5,
            lineDataSymbol: 'circle',
            lineDataSymbolSize: 4,
            lineDataSymbolLineSize: 0,

            showValue: true,
            dataLabelFormatCode: '0.00',
            dataLabelFontFace: this.brandInfoMedicine.font.title,
            dataLabelFontSize: 5,
            dataLabelColor: '000000',
            dataLabelPosition: 't',

            valAxisMinVal: 0,
            valAxisMaxVal: 105,
            valAxisMajorUnit: 10,
            valAxisLabelFormatCode: '0"%"',
            valAxisLabelFontFace: this.brandInfoMedicine.font.title,
            valAxisLabelFontSize: 5.5,
            valAxisLabelColor: '555555',
            valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

            catAxisLabelFontFace: this.brandInfoMedicine.font.title,
            catAxisLabelFontSize: 5.5,
            catAxisLabelColor: '555555',
            catAxisLabelRotate: 0,
            catAxisLineShow: false,
            catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

            plotArea: { fill: { color: 'FFFFFF' } },
            chartArea: {
              fill: { color: 'FFFFFF' },
              border: { pt: 0, color: 'FFFFFF' },
            },
            chartColors: ['#00CEBC', '#141F58'],
            showTitle: false,
          } as any,
        );

        // COMMENTI
        slide9.addText(
          [
            {
              text: 'Commenti:',
              options: {
                bold: true,
                color: this.brandInfoMedicine.colors.subtitle,
                fontSize: 11,
              },
            },
            {
              text: '\nQui puoi scrivere i tuoi commenti.',
              options: {
                italic: true,
                color: '404040',
                fontSize: 9,
              },
            },
          ],
          {
            x: 6.2,
            y: 1.65,
            w: '35%',
            h: '50%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
            valign: 'top',
          },
        );
      }
    }
    //
    // slideEconomiaA
    if (
      this.widgetsAvailable.some((widget) => widget.id === 16) &&
      this.openToEconomiaLabels.length > 0
    ) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 16)?.name;
      const slideEconomiaA = pptx.addSlide();
      slideEconomiaA.addText(
        this.medicineName.toUpperCase() || 'NOME FARMACO',
        {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.title, //color:'80eb07',
          bold: true,
          align: 'left',
        },
      );

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slideEconomiaA.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slideEconomiaA.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slideEconomiaA.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slideEconomiaA.addText(TOOLTIPS_NT.find((t) => t.id === 16)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.92, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      this.addCurveLegend(pptx, slideEconomiaA, 1.95, 4.63);

      slideEconomiaA.addChart(
        pptx.ChartType.line,
        [
          {
            name: 'Forecast',
            labels: this.openToEconomiaLabels,
            values: this.openToEconomiaTargetData,
            line: { color: '#00CEBC' },
          },
          {
            name: 'Actual',
            labels: this.openToEconomiaLabels,
            values: this.openToEconomiaActualData,
            line: { color: '#141F58' },
          },
        ],
        {
          x: 0.5,
          y: 1.68,
          w: 4.2,
          h: 2.75,

          // --- Legend ---
          showLegend: false,

          // --- Lines & markers ---
          lineSize: 1.5,
          lineDataSymbol: 'circle',
          lineDataSymbolSize: 4,
          lineDataSymbolLineSize: 0, // no outline

          // --- Values / labels on points ---
          showValue: false,

          // --- Y axis (0–100%, step 10) ---
          valAxisMinVal: 0,
          valAxisMaxVal: 105,
          valAxisMajorUnit: 10,
          valAxisLabelFormatCode: '0"%"', // 0%, 10%, 20%, ...
          valAxisLabelFontFace: this.brandInfoMedicine.font.title,
          valAxisLabelFontSize: 5,
          valAxisLabelColor: '555555',
          valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

          // --- X axis (dates, rotated) ---
          catAxisLabelFontFace: this.brandInfoMedicine.font.title,
          catAxisLabelFontSize: 5,
          catAxisLabelColor: '555555',
          catAxisLabelRotate: 0,
          catAxisLineShow: false,
          catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

          // --- General ---
          plotArea: { fill: { color: 'FFFFFF' } },
          chartArea: {
            fill: { color: 'FFFFFF' },
            border: { pt: 0, color: 'FFFFFF' },
          },
          chartColors: ['#00CEBC', '#141F58'],
          showTitle: false,
        },
      );

      //@ts-ignore
      if (
        this.openToEconomiaTableData &&
        this.openToEconomiaTableData.length > 0
      ) {
        slideEconomiaA.addTable(this.openToEconomiaTableData, {
          fill: { color: 'FFFFFF' },
          x: 5.5,
          y: 1.75,
          colW: 1.0,
          rowH: 0.2,
          valign: 'middle',
          bold: false,
          fontSize: 6.5,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
      // slideEconomiaB
      if (
        this.widgetsAvailable.some((widget) => widget.id === 16) &&
        this.openToEconomiaLabels.length > 0
      ) {
        const widgetName = this.widgetsAvailable.find((w) => w.id === 16)?.name;

        // find the last index with a non-null value for actual
        let lastActualIndex = -1;
        for (let i = this.openToEconomiaLabels.length - 1; i >= 0; i--) {
          if (
            this.openToEconomiaActualData[i] !== null &&
            this.openToEconomiaActualData[i] !== undefined
          ) {
            lastActualIndex = i;
            break;
          }
        }

        // create troncate version of actual data
        const actualValuesTruncated =
          lastActualIndex >= 0
            ? this.openToEconomiaActualData.slice(0, lastActualIndex + 1)
            : [];

        const slideEconomiaB = pptx.addSlide();

        slideEconomiaB.addText(
          this.medicineName.toUpperCase() || 'NOME FARMACO',
          {
            x: 0.5,
            y: 0.3,
            w: '90%',
            h: '8%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.title,
            color: this.brandInfoMedicine.colors.title,
            bold: true,
            align: 'left',
          },
        );

        // Logo
        slideEconomiaB.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });

        if (widgetName) {
          slideEconomiaB.addText(widgetName, {
            x: 0.5,
            y: 0.6,
            w: '70%',
            h: '8%',
            fontSize: 14,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: this.brandInfoMedicine.colors.subtitle,
            bold: true,
            align: 'left',
          });
        }

        slideEconomiaB.addText(
          TOOLTIPS_NT.find((t) => t.id === 16)?.text || '',
          {
            x: 0.5,
            y: 0.92,
            w: '93%',
            h: '8%',
            fontSize: 9.5,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
          },
        );

        // graph
        this.addCurveLegend(pptx, slideEconomiaB, 2.57, 4.99);

        slideEconomiaB.addChart(
          this.buildCurveChartTypes(
            pptx,
            this.openToEconomiaLabels,
            this.openToEconomiaTargetData,
            actualValuesTruncated,
          ),
          {
            x: 0.5,
            y: 1.58,
            w: 5.45,
            h: 3.25,

            showLegend: false,

            lineSize: 1.5,
            lineDataSymbol: 'circle',
            lineDataSymbolSize: 4,
            lineDataSymbolLineSize: 0,

            showValue: true,
            dataLabelFormatCode: '0.00',
            dataLabelFontFace: this.brandInfoMedicine.font.title,
            dataLabelFontSize: 5,
            dataLabelColor: '000000',
            dataLabelPosition: 't',

            valAxisMinVal: 0,
            valAxisMaxVal: 105,
            valAxisMajorUnit: 10,
            valAxisLabelFormatCode: '0"%"',
            valAxisLabelFontFace: this.brandInfoMedicine.font.title,
            valAxisLabelFontSize: 5.5,
            valAxisLabelColor: '555555',
            valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

            catAxisLabelFontFace: this.brandInfoMedicine.font.title,
            catAxisLabelFontSize: 5.5,
            catAxisLabelColor: '555555',
            catAxisLabelRotate: 0,
            catAxisLineShow: false,
            catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

            plotArea: { fill: { color: 'FFFFFF' } },
            chartArea: {
              fill: { color: 'FFFFFF' },
              border: { pt: 0, color: 'FFFFFF' },
            },
            chartColors: ['#00CEBC', '#141F58'],
            showTitle: false,
          } as any,
        );

        // COMMENTI
        slideEconomiaB.addText(
          [
            {
              text: 'Commenti:',
              options: {
                bold: true,
                color: this.brandInfoMedicine.colors.subtitle,
                fontSize: 11,
              },
            },
            {
              text: '\nQui puoi scrivere i tuoi commenti.',
              options: {
                italic: true,
                color: '404040',
                fontSize: 9,
              },
            },
          ],
          {
            x: 6.2,
            y: 1.65,
            w: '35%',
            h: '50%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
            valign: 'top',
          },
        );
      }
    }
    //
    // SLIDE 10 - widget-curva-mercato (id: 4)
    if (
      this.widgetsAvailable.some((widget) => widget.id === 4) &&
      this.openToMarketLabels.length > 0
    ) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 4)?.name;
      const slide10 = pptx.addSlide();
      slide10.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide10.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slide10.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slide10.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide10.addText(TOOLTIPS_NT.find((t) => t.id === 4)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.92, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      this.addCurveLegend(pptx, slide10, 1.95, 4.63);

      slide10.addChart(
        pptx.ChartType.line,
        [
          {
            name: 'Forecast',
            labels: this.openToMarketLabels,
            values: this.openToMarketTargetData,
            line: { color: '#00CEBC' },
          },
          {
            name: 'Actual',
            labels: this.openToMarketLabels,
            values: this.openToMarketActualData,
            line: { color: '#141F58' },
          },
        ],
        {
          x: 0.5,
          y: 1.68,
          w: 4.2,
          h: 2.75,

          // --- Legend ---
          showLegend: false,

          // --- Lines & markers ---
          lineSize: 1.5,
          lineDataSymbol: 'circle',
          lineDataSymbolSize: 4,
          lineDataSymbolLineSize: 0, // no outline

          // --- Values / labels on points ---
          showValue: false,

          // --- Y axis (0–100%, step 10) ---
          valAxisMinVal: 0,
          valAxisMaxVal: 105,
          valAxisMajorUnit: 10,
          valAxisLabelFormatCode: '0"%"', // 0%, 10%, 20%, ...
          valAxisLabelFontFace: this.brandInfoMedicine.font.title,
          valAxisLabelFontSize: 5,
          valAxisLabelColor: '555555',
          valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

          // --- X axis (dates, rotated) ---
          catAxisLabelFontFace: this.brandInfoMedicine.font.title,
          catAxisLabelFontSize: 5,
          catAxisLabelColor: '555555',
          catAxisLabelRotate: 0,
          catAxisLineShow: false,
          catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

          // --- General ---
          plotArea: { fill: { color: 'FFFFFF' } },
          chartArea: {
            fill: { color: 'FFFFFF' },
            border: { pt: 0, color: 'FFFFFF' },
          },
          chartColors: ['#00CEBC', '#141F58'],
          showTitle: false,
        },
      );

      //@ts-ignore
      if (this.openToMarketTableData && this.openToMarketTableData.length > 0) {
        slide10.addTable(this.openToMarketTableData, {
          fill: { color: 'FFFFFF' },
          x: 5.5,
          y: 1.75,
          colW: 1.0,
          rowH: 0.2,
          valign: 'middle',
          bold: false,
          fontSize: 6.5,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
      // slide 11
      if (
        this.widgetsAvailable.some((widget) => widget.id === 4) &&
        this.openToMarketLabels.length > 0
      ) {
        const widgetName = this.widgetsAvailable.find((w) => w.id === 4)?.name;

        // find the last index with a non-null value for actual
        let lastActualIndex = -1;
        for (let i = this.openToMarketLabels.length - 1; i >= 0; i--) {
          if (
            this.openToMarketActualData[i] !== null &&
            this.openToMarketActualData[i] !== undefined
          ) {
            lastActualIndex = i;
            break;
          }
        }

        // create troncate version of actual data
        const actualValuesTruncated =
          lastActualIndex >= 0
            ? this.openToMarketActualData.slice(0, lastActualIndex + 1)
            : [];

        const slide11 = pptx.addSlide();

        slide11.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        });

        // Logo
        slide11.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });

        if (widgetName) {
          slide11.addText(widgetName, {
            x: 0.5,
            y: 0.6,
            w: '70%',
            h: '8%',
            fontSize: 14,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: this.brandInfoMedicine.colors.subtitle,
            bold: true,
            align: 'left',
          });
        }

        slide11.addText(TOOLTIPS_NT.find((t) => t.id === 4)?.text || '', {
          x: 0.5,
          y: 0.92,
          w: '93%',
          h: '8%',
          fontSize: 9.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
        });

        // graph
        this.addCurveLegend(pptx, slide11, 2.57, 4.99);

        slide11.addChart(
          this.buildCurveChartTypes(
            pptx,
            this.openToMarketLabels,
            this.openToMarketTargetData,
            actualValuesTruncated,
          ),
          {
            x: 0.5,
            y: 1.58,
            w: 5.45,
            h: 3.25,

            showLegend: false,

            lineSize: 1.5,
            lineDataSymbol: 'circle',
            lineDataSymbolSize: 4,
            lineDataSymbolLineSize: 0,

            showValue: true,
            dataLabelFormatCode: '0.00',
            dataLabelFontFace: this.brandInfoMedicine.font.title,
            dataLabelFontSize: 5,
            dataLabelColor: '000000',
            dataLabelPosition: 't',

            valAxisMinVal: 0,
            valAxisMaxVal: 105,
            valAxisMajorUnit: 10,
            valAxisLabelFormatCode: '0"%"',
            valAxisLabelFontFace: this.brandInfoMedicine.font.title,
            valAxisLabelFontSize: 5.5,
            valAxisLabelColor: '555555',
            valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

            catAxisLabelFontFace: this.brandInfoMedicine.font.title,
            catAxisLabelFontSize: 5.5,
            catAxisLabelColor: '555555',
            catAxisLabelRotate: 0,
            catAxisLineShow: false,
            catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

            plotArea: { fill: { color: 'FFFFFF' } },
            chartArea: {
              fill: { color: 'FFFFFF' },
              border: { pt: 0, color: 'FFFFFF' },
            },
            chartColors: ['#00CEBC', '#141F58'],
            showTitle: false,
          } as any,
        );

        // COMMENTI
        slide11.addText(
          [
            {
              text: 'Commenti:',
              options: {
                bold: true,
                color: this.brandInfoMedicine.colors.subtitle,
                fontSize: 11,
              },
            },
            {
              text: '\nQui puoi scrivere i tuoi commenti.',
              options: {
                italic: true,
                color: '404040',
                fontSize: 9,
              },
            },
          ],
          {
            x: 6.2,
            y: 1.65,
            w: '35%',
            h: '50%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
            valign: 'top',
          },
        );
      }
    }
    //

    // SLIDE 11b/11c - widget-curva-mercato-30-giorni (id: 21)
    // Forecast and Actual are rendered as two separate charts (Forecast on top, Actual below),
    // like the two sections of the widget, each one on its own 0-100% scale.
    if (
      (this.hasOpenToMarket30DaysWidget(21) || this.hasOpenToMarket30DaysWidget(23)) &&
      this.openToMarket30DaysLabels.length > 0
    ) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 21)?.name;
      const mergedWidgetName = this.widgetsAvailable.find((w) => w.id === 23)?.name;

      const unifiedTooltipText =
        'Versione unificata delle curve Forecast e Actual sullo stesso piano, con valori aggregati per periodi di 30 giorni.';

      const addUnifiedSlideHeader = (slide: PptxGenJS.Slide, titleSuffix = '') => {
        slide.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        });

        slide.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });

        if (mergedWidgetName) {
          slide.addText(`${mergedWidgetName}${titleSuffix}`, {
            x: 0.5,
            y: 0.6,
            w: '70%',
            h: '8%',
            fontSize: 14,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: this.brandInfoMedicine.colors.subtitle,
            bold: true,
            align: 'left',
          });
        }

        slide.addText(unifiedTooltipText, {
          x: 0.5,
          y: 0.92,
          w: '93%',
          h: '8%',
          fontSize: 9.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
        });
      };

      // merged curve (id: 23) first: it is the main version of this widget
      if (this.hasOpenToMarket30DaysWidget(23)) {
        // SLIDE 11d - widget-curva-mercato-30-giorni-merged (id: 23)
        const clamp = (v: number | null) =>
          v == null ? null : Math.min(100, Math.max(0, v));

        let lastActualIndex30 = -1;
        for (let i = this.openToMarket30DaysActualData.length - 1; i >= 0; i--) {
          if (this.openToMarket30DaysActualData[i] != null) {
            lastActualIndex30 = i;
            break;
          }
        }

        const actualValuesTruncated30 =
          lastActualIndex30 >= 0
            ? this.openToMarket30DaysActualData
                .slice(0, lastActualIndex30 + 1)
                .map(clamp)
            : [];

        // the table is split in pages of 8 months (Mese 0-7): every page repeats the chart,
        // with a Roman numeral at the end of the title when there is more than one page
        const mergedRowsPerSlide = 8;
        const [mergedHeader, ...mergedRows] = this.openToMarket30DaysMergedTableData ?? [];
        const mergedPages = Math.max(1, Math.ceil(mergedRows.length / mergedRowsPerSlide));

        const addMergedChart = (slide: PptxGenJS.Slide) => {
          this.addCurveLegend(pptx, slide, 1.95, 4.63);

          slide.addChart(
            pptx.ChartType.line,
            [
              {
                name: 'Forecast',
                labels: this.openToMarket30DaysLabels,
                values: this.openToMarket30DaysTargetData.map(clamp) as number[],
                line: { color: '#00CEBC' },
              },
              {
                name: 'Actual',
                labels: this.openToMarket30DaysLabels,
                values: this.openToMarket30DaysActualData.map(clamp) as number[],
                line: { color: '#141F58' },
              },
            ],
            {
              x: 0.5,
              y: 1.68,
              w: 4.2,
              h: 2.75,

              showLegend: false,

              lineSize: 1.5,
              lineDataSymbol: 'circle',
              lineDataSymbolSize: 4,
              lineDataSymbolLineSize: 0,

              showValue: false,

              valAxisMinVal: 0,
              valAxisMaxVal: 105,
              valAxisMajorUnit: 10,
              valAxisLabelFormatCode: '0"%"',
              valAxisLabelFontFace: this.brandInfoMedicine.font.title,
              valAxisLabelFontSize: 5,
              valAxisLabelColor: '555555',
              valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

              catAxisLabelFontFace: this.brandInfoMedicine.font.title,
              catAxisLabelFontSize: 5,
              catAxisLabelColor: '555555',
              catAxisLabelRotate: -45,
              catAxisLineShow: false,
              catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

              plotArea: { fill: { color: 'FFFFFF' } },
              chartArea: {
                fill: { color: 'FFFFFF' },
                border: { pt: 0, color: 'FFFFFF' },
              },
              chartColors: ['#00CEBC', '#141F58'],
              showTitle: false,
            },
          );
        };

        for (let page = 0; page < mergedPages; page++) {
          const slide11d = pptx.addSlide();
          addUnifiedSlideHeader(
            slide11d,
            mergedPages > 1 ? ` ${this.toRoman(page + 1)}` : '',
          );
          addMergedChart(slide11d);

          const pageRows = mergedRows.slice(
            page * mergedRowsPerSlide,
            (page + 1) * mergedRowsPerSlide,
          );

          if (mergedHeader && pageRows.length > 0) {
            slide11d.addTable([mergedHeader, ...pageRows], {
              fill: { color: 'FFFFFF' },
              x: 5.5,
              y: 1.75,
              colW: [0.7, 1.35, 1.35, 0.7],
              rowH: [0.2, ...Array(pageRows.length).fill(0.34)],
              valign: 'middle',
              bold: false,
              fontSize: 6.5,
              color: '204131',
              border: { pt: 1.25, color: 'F1F1F1' },
            });
          }
        }

        // SLIDE 11e - widget-curva-mercato-30-giorni-merged (id: 23)
        const slide11e = pptx.addSlide();
        addUnifiedSlideHeader(slide11e);

        this.addCurveLegend(pptx, slide11e, 2.57, 4.99);

        slide11e.addChart(
          this.buildCurveChartTypes(
            pptx,
            this.openToMarket30DaysLabels,
            this.openToMarket30DaysTargetData.map(clamp),
            actualValuesTruncated30,
          ),
          {
            x: 0.5,
            y: 1.58,
            w: 5.45,
            h: 3.25,

            showLegend: false,

            lineSize: 1.5,
            lineDataSymbol: 'circle',
            lineDataSymbolSize: 4,
            lineDataSymbolLineSize: 0,

            showValue: true,
            dataLabelFormatCode: '0.00',
            dataLabelFontFace: this.brandInfoMedicine.font.title,
            dataLabelFontSize: 5,
            dataLabelColor: '000000',
            dataLabelPosition: 't',

            valAxisMinVal: 0,
            valAxisMaxVal: 105,
            valAxisMajorUnit: 10,
            valAxisLabelFormatCode: '0"%"',
            valAxisLabelFontFace: this.brandInfoMedicine.font.title,
            valAxisLabelFontSize: 5.5,
            valAxisLabelColor: '555555',
            valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

            catAxisLabelFontFace: this.brandInfoMedicine.font.title,
            catAxisLabelFontSize: 5.5,
            catAxisLabelColor: '555555',
            catAxisLabelRotate: -45,
            catAxisLineShow: false,
            catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

            plotArea: { fill: { color: 'FFFFFF' } },
            chartArea: {
              fill: { color: 'FFFFFF' },
              border: { pt: 0, color: 'FFFFFF' },
            },
            chartColors: ['#00CEBC', '#141F58'],
            showTitle: false,
          } as any,
        );

        slide11e.addText(
          [
            {
              text: 'Commenti:',
              options: {
                bold: true,
                color: this.brandInfoMedicine.colors.subtitle,
                fontSize: 11,
              },
            },
            {
              text: '\nQui puoi scrivere i tuoi commenti.',
              options: {
                italic: true,
                color: '404040',
                fontSize: 9,
              },
            },
          ],
          {
            x: 6.2,
            y: 1.65,
            w: '35%',
            h: '50%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
            valign: 'top',
          },
        );
      }

      // forecast and actual on two separate charts (id: 21)
      if (this.hasOpenToMarket30DaysWidget(21)) {
        // slide 11b - widget-curva-mercato-30-giorni (id: 21)
        const slide11b = pptx.addSlide();
        this.addOpenToMarket30DaysSlideHeader(slide11b, widgetName);
        this.addOpenToMarket30DaysCharts(
          pptx,
          slide11b,
          { x: 0.5, y: 1.4, w: 4.8, h: 4.0 },
          false,
        );

        if (
          this.openToMarket30DaysTableData &&
          this.openToMarket30DaysTableData.length > 0
        ) {
          slide11b.addTable(this.openToMarket30DaysTableData, {
            fill: { color: 'FFFFFF' },
            x: 5.5,
            y: 1.75,
            colW: 1.0,
            rowH: 0.2,
            valign: 'middle',
            bold: false,
            fontSize: 6.5,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          });
        }

        // slide 11c - widget-curva-mercato-30-giorni (id: 21)
        const slide11c = pptx.addSlide();
        this.addOpenToMarket30DaysSlideHeader(slide11c, widgetName);
        this.addOpenToMarket30DaysCharts(
          pptx,
          slide11c,
          { x: 0.5, y: 1.4, w: 5.45, h: 4.0 },
          true,
        );

        // COMMENTI
        slide11c.addText(
          [
            {
              text: 'Commenti:',
              options: {
                bold: true,
                color: this.brandInfoMedicine.colors.subtitle,
                fontSize: 11,
              },
            },
            {
              text: '\nQui puoi scrivere i tuoi commenti.',
              options: {
                italic: true,
                color: '404040',
                fontSize: 9,
              },
            },
          ],
          {
            x: 6.2,
            y: 1.65,
            w: '35%',
            h: '50%',
            fontSize: 11,
            fontFace: this.brandInfoMedicine.font.subtitle,
            color: '000000',
            bold: false,
            align: 'left',
            valign: 'top',
          },
        );
      }
    }
    //

    // SLIDE 12 - widget-monitoringForecastVsActualRegionalLevel (id: 7)
    if (this.widgetsAvailable.some((widget) => widget.id === 7)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 7)?.name;
      const slide12 = pptx.addSlide();
      slide12.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide12.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slide12.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slide12.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide12.addText(TOOLTIPS_NT.find((t) => t.id === 7)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.9, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      if (
        this.leftMonitoringForecastvsActualTableRows &&
        this.leftMonitoringForecastvsActualTableRows.length > 0
      ) {
        slide12.addTable(this.leftMonitoringForecastvsActualTableRows, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (
        this.rightMonitoringForecastvsActualTableRows &&
        this.rightMonitoringForecastvsActualTableRows.length > 0
      ) {
        slide12.addTable(this.rightMonitoringForecastvsActualTableRows, {
          fill: { color: 'FFFFFF' },
          x: 5.2,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    }
    // SLIDE 12b - widget-monitoringCompleteAccess (id: 12)
    if (this.widgetsAvailable.some((widget) => widget.id === 12)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 12)?.name;
      const slide12b = pptx.addSlide();

      slide12b.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });

      slide12b.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      if (widgetName) {
        slide12b.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }

      slide12b.addText(TOOLTIPS_NT.find((t) => t.id === 12)?.text || '', {
        x: 0.5,
        y: 0.97,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      if (this.leftMonitoringCompleteAccessTableRows?.length > 0) {
        slide12b.addTable(this.leftMonitoringCompleteAccessTableRows, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (this.rightMonitoringCompleteAccessTableRows?.length > 0) {
        slide12b.addTable(this.rightMonitoringCompleteAccessTableRows, {
          fill: { color: 'FFFFFF' },
          x: 5.2,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    }
    // SLIDE 12c - widget-monitoringAggiudicazione (id: 13)
    if (this.widgetsAvailable.some((widget) => widget.id === 13)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 13)?.name;
      const slide12c = pptx.addSlide();

      slide12c.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });

      slide12c.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      if (widgetName) {
        slide12c.addText(widgetName, {
          x: 0.5,
          y: 0.6,
          w: '70%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });
      }

      slide12c.addText(TOOLTIPS_NT.find((t) => t.id === 13)?.text || '', {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });

      if (this.leftMonitoringAggiudicazioneTableRows?.length > 0) {
        slide12c.addTable(this.leftMonitoringAggiudicazioneTableRows, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (this.rightMonitoringAggiudicazioneTableRows?.length > 0) {
        slide12c.addTable(this.rightMonitoringAggiudicazioneTableRows, {
          fill: { color: 'FFFFFF' },
          x: 5.2,
          y: 1.5,
          colW: [1.0, 1.1, 1.1, 1.0],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 8,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    }

    // SLIDE 13 - widget-forecastTimeProgress (id: 8)
    if (this.widgetsAvailable.some((widget) => widget.id === 8)) {
      const widgetName = this.widgetsAvailable.find((w) => w.id === 8)?.name;
      const slide13 = pptx.addSlide();
      slide13.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
        color: this.brandInfoMedicine.colors.title, //color:'80eb07',
        bold: true,
        align: 'left',
      });

      /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

      slide13.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      //company logo
      /*slide13.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

      if (widgetName) {
        slide13.addText(widgetName, {
          x: 0.5, // Slightly from the left edge
          y: 0.6, // Slightly from the top edge
          w: '70%', // Full slide width
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
          color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
          bold: true,
          align: 'left',
        });
      }

      slide13.addText(TOOLTIPS_NT.find((t) => t.id === 8)?.text || '', {
        x: 0.5, // Slightly from the left edge
        y: 0.9, // Slightly from the top edge
        w: '93%', // Full slide width
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
        color: '000000', //color:'000000', // Aqua color
        bold: false,
        align: 'left',
      });

      //@ts-ignore
      if (
        this.leftRegionalAccessTableRows &&
        this.leftRegionalAccessTableRows.length > 0
      ) {
        slide13.addTable(this.leftRegionalAccessTableRows, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [1.3, 1.3, 1.3],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 7,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (
        this.rightRegionalAccessTableRows &&
        this.rightRegionalAccessTableRows.length > 0
      ) {
        slide13.addTable(this.rightRegionalAccessTableRows, {
          fill: { color: 'FFFFFF' },
          x: 5.2,
          y: 1.5,
          colW: [1.3, 1.3, 1.3],
          rowH: 0.3,
          valign: 'middle',
          bold: false,
          fontSize: 7,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    }

    // ============ FORECAST ACCURACY SLIDES ============
    const addFaSlideHeader = (slide: any, title: string, subtitle: string) => {
      slide.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5,
        y: 0.3,
        w: '90%',
        h: '8%',
        fontSize: 11,
        fontFace: this.brandInfoMedicine.font.title,
        color: this.brandInfoMedicine.colors.title,
        bold: true,
        align: 'left',
      });

      slide.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      slide.addText(title, {
        x: 0.5,
        y: 0.6,
        w: '88%',
        h: '8%',
        fontSize: 14,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: this.brandInfoMedicine.colors.subtitle,
        bold: true,
        align: 'left',
      });

      slide.addText(subtitle, {
        x: 0.5,
        y: 0.9,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      });
    };

    // Renders one slide per chunk of `faRowsPerSlide` months; appends a Roman
    // numeral to the title when the data spans more than one slide.
    const faRowsPerSlide = 10;
    const renderForecastAccuracySlides = (
      rows: ForecastAccuracyRow[],
      widgetName: string,
      tooltipText: string,
    ) => {
      if (!rows.length) return;

      const totalPages = Math.max(1, Math.ceil(rows.length / faRowsPerSlide));

      for (let page = 0; page < totalPages; page++) {
        const pageRows = rows.slice(
          page * faRowsPerSlide,
          (page + 1) * faRowsPerSlide,
        );

        const slideFa = pptx.addSlide();
        addFaSlideHeader(
          slideFa,
          totalPages > 1
            ? `${widgetName} ${this.toRoman(page + 1)}`
            : widgetName,
          tooltipText,
        );

        slideFa.addTable(this.mapForecastAccuracyRowsToPptTable(pageRows), {
          fill: { color: 'FFFFFF' },
          x: 1.4,
          y: 1.6,
          colW: [1.8, 1.8, 1.8, 1.8],
          rowH: 0.32,
          valign: 'middle',
          fontSize: 7.5,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }
    };

    // Slide FA-1 - Forecast Accuracy in Inclusione Regionale (widget id 17)
    if (this.widgetsAvailable.some((w) => w.id === 17)) {
      renderForecastAccuracySlides(
        this.forecastAccuracyOpenToAccessRows,
        this.widgetsAvailable.find((w) => w.id === 17)?.name ||
          'Forecast Accuracy in Inclusione Regionale',
        TOOLTIPS_NT.find((t) => t.id === 17)?.text || '',
      );
    }

    // Slide FA-2 - Forecast Accuracy Apertura in Economia (widget id 18)
    if (this.widgetsAvailable.some((w) => w.id === 18)) {
      renderForecastAccuracySlides(
        this.forecastAccuracyOpenToEconomiaRows,
        this.widgetsAvailable.find((w) => w.id === 18)?.name ||
          'Forecast Accuracy Apertura in Economia',
        TOOLTIPS_NT.find((t) => t.id === 18)?.text || '',
      );
    }

    // Slide FA-3 - Forecast Accuracy Apertura al Mercato (widget id 19)
    if (this.widgetsAvailable.some((w) => w.id === 19)) {
      renderForecastAccuracySlides(
        this.forecastAccuracyOpenToMarketRows,
        this.widgetsAvailable.find((w) => w.id === 19)?.name ||
          'Forecast Accuracy Apertura al Mercato',
        TOOLTIPS_NT.find((t) => t.id === 19)?.text || '',
      );
    }

    // ============ INCLUSION PROCESS TOOL SLIDES (Processo di Inclusione) ============
    if (
      this.widgetsAvailable.some((w) => w.id === 14) &&
      this.inclusionProcessData
    ) {
      const ip = this.inclusionProcessData;

      // Slide IP-1 - Process Overview (4 stages side-by-side)
      const slideIpOverview = pptx.addSlide();
      slideIpOverview.addText(
        this.medicineName.toUpperCase() || 'NOME FARMACO',
        {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        },
      );

      slideIpOverview.addImage({
        path: this.brandInfoMedicine.logo.url,
        x: 9.2,
        y: 0.3,
        w: '4%',
        h: '6%',
      });

      slideIpOverview.addText('Processo di Inclusione', {
        x: 0.5,
        y: 0.6,
        w: '88%',
        h: '8%',
        fontSize: 14,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: this.brandInfoMedicine.colors.subtitle,
        bold: true,
        align: 'left',
      });

      slideIpOverview.addText(
        TOOLTIPS_NT.find((t) => t.id === 14)?.text || '',
        {
          x: 0.5,
          y: 0.9,
          w: '93%',
          h: '8%',
          fontSize: 9.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
        },
      );

      const ipStages = [
        {
          label: 'Start',
          value: ip.metrics.stepZeroCount,
          desc: 'Gazzetta Ufficiale della Repubblica Italiana',
        },
        {
          label: 'Inclusione Regionale',
          value: ip.metrics.openToAccessCount,
          desc: 'Delibera Centri Prescrittori Regionale o Inserimento in Prontuario Terapeutico Regionale o Delibera di Recepimento Regionale',
        },
        {
          label: 'Aggiudicazione Gara',
          value: ip.metrics.aggiudicazioneGaraCount,
          desc: 'Conclusione della procedura di gara ed assegnazione del CIG',
        },
        {
          label: 'Possibilità di Acquisto',
          value: ip.metrics.openToMarketHospitalCount,
          desc: "da parte della struttura, a seguito del recepimento dei termini della gara centralizzata e dell'inserimento del CIG",
        },
      ];

      const ipColW = 2.3;
      const ipStartX = 0.5;
      const ipY = 1.8;

      // Same per-card tint progression as inclusion-process-tool-national
      // (bg-white, bg-dimot-1/[0.03], bg-dimot-1/[0.07], bg-dimot-1/[0.12])
      const ipCardFills = ['FFFFFF', 'F8F8FA', 'EFEFF3', 'E3E4EB'];

      ipStages.forEach((stage, idx) => {
        const x = ipStartX + idx * ipColW;

        slideIpOverview.addShape(pptx.ShapeType.rect, {
          x,
          y: ipY,
          w: ipColW - 0.1,
          h: 2.7,
          fill: { color: ipCardFills[idx] },
          line: { color: 'E5E7EB', width: 0.75 },
        });

        slideIpOverview.addText('STEP', {
          x,
          y: ipY + 0.15,
          w: ipColW - 0.1,
          h: 0.3,
          fontSize: 8,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'center',
        });

        slideIpOverview.addText(stage.label, {
          x,
          y: ipY + 0.45,
          w: ipColW - 0.1,
          h: 0.4,
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'center',
        });

        slideIpOverview.addText(stage.desc, {
          x: x + 0.1,
          y: ipY + 0.85,
          w: ipColW - 0.3,
          h: 1.0,
          fontSize: 6.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '666666',
          align: 'center',
          valign: 'top',
        });

        slideIpOverview.addText(`${stage.value}`, {
          x,
          y: ipY + 1.95,
          w: ipColW - 0.1,
          h: 0.6,
          fontSize: 22,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'center',
        });
      });

      // Helper to draw the standard header/subtitle block for detail slides
      const addIpDetailHeader = (
        slide: any,
        title: string,
        subtitle: string,
      ) => {
        slide.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
          x: 0.5,
          y: 0.3,
          w: '90%',
          h: '8%',
          fontSize: 11,
          fontFace: this.brandInfoMedicine.font.title,
          color: this.brandInfoMedicine.colors.title,
          bold: true,
          align: 'left',
        });

        slide.addImage({
          path: this.brandInfoMedicine.logo.url,
          x: 9.2,
          y: 0.3,
          w: '4%',
          h: '6%',
        });

        slide.addText(title, {
          x: 0.5,
          y: 0.6,
          w: '88%',
          h: '8%',
          fontSize: 14,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: this.brandInfoMedicine.colors.subtitle,
          bold: true,
          align: 'left',
        });

        slide.addText(subtitle, {
          x: 0.5,
          y: 0.9,
          w: '93%',
          h: '8%',
          fontSize: 9.5,
          fontFace: this.brandInfoMedicine.font.subtitle,
          color: '000000',
          bold: false,
          align: 'left',
        });
      };

      // Slide IP-2 - Start detail
      const slideIpStart = pptx.addSlide();
      addIpDetailHeader(
        slideIpStart,
        'Processo di Inclusione - Step Start',
        'Gazzetta Ufficiale della Repubblica Italiana',
      );

      if (this.inclusionStartTableData?.length) {
        slideIpStart.addTable(this.inclusionStartTableData, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [2.6, 2.6, 2.6],
          rowH: 0.35,
          valign: 'middle',
          fontSize: 7.5,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // Slide IP-3 - Inclusione Regionale detail
      const slideIpRegionale = pptx.addSlide();
      addIpDetailHeader(
        slideIpRegionale,
        'Processo di Inclusione - Step Inclusione Regionale',
        'Delibera Centri Prescrittori Regionale o Inserimento in Prontuario Terapeutico Regionale o Delibera di Recepimento Regionale',
      );

      if (this.leftInclusionRegionaleTableRows?.length > 0) {
        slideIpRegionale.addTable(this.leftInclusionRegionaleTableRows, {
          fill: { color: 'FFFFFF' },
          x: 0.6,
          y: 1.5,
          colW: [1.3, 1.3, 1.3],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 7,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      if (this.rightInclusionRegionaleTableRows?.length > 0) {
        slideIpRegionale.addTable(this.rightInclusionRegionaleTableRows, {
          fill: { color: 'FFFFFF' },
          x: 5.2,
          y: 1.5,
          colW: [1.3, 1.3, 1.3],
          rowH: 0.3,
          valign: 'middle',
          fontSize: 7,
          color: '204131',
          border: { pt: 1.25, color: 'F1F1F1' },
        });
      }

      // Slide IP-4 - Aggiudicazione Gara detail
      const slideIpAggiudicazione = pptx.addSlide();
      addIpDetailHeader(
        slideIpAggiudicazione,
        'Processo di Inclusione - Step Aggiudicazione Gara',
        'Conclusione della procedura di gara ed assegnazione del CIG',
      );

      if (this.leftInclusionAggiudicazioneTableRows?.length > 0) {
        slideIpAggiudicazione.addTable(
          this.leftInclusionAggiudicazioneTableRows,
          {
            fill: { color: 'FFFFFF' },
            x: 0.6,
            y: 1.5,
            colW: [1.3, 1.3, 1.3],
            rowH: 0.3,
            valign: 'middle',
            fontSize: 7,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          },
        );
      }

      if (this.rightInclusionAggiudicazioneTableRows?.length > 0) {
        slideIpAggiudicazione.addTable(
          this.rightInclusionAggiudicazioneTableRows,
          {
            fill: { color: 'FFFFFF' },
            x: 5.2,
            y: 1.5,
            colW: [1.3, 1.3, 1.3],
            rowH: 0.3,
            valign: 'middle',
            fontSize: 7,
            color: '204131',
            border: { pt: 1.25, color: 'F1F1F1' },
          },
        );
      }

      // Slide IP-5(+) - Possibilità di Acquisto detail (paginated: hospitals can be numerous)
      const acquistoRowsPerSlide = 12;

      if (this.inclusionAcquistoTableRows) {
        const totalAcquistoPages = Math.max(
          1,
          Math.ceil(
            this.inclusionAcquistoTableRows.length / acquistoRowsPerSlide,
          ),
        );

        for (let page = 0; page < totalAcquistoPages; page++) {
          const pageRows = this.inclusionAcquistoTableRows.slice(
            page * acquistoRowsPerSlide,
            (page + 1) * acquistoRowsPerSlide,
          );

          const slideIpAcquisto = pptx.addSlide();
          addIpDetailHeader(
            slideIpAcquisto,
            totalAcquistoPages > 1
              ? `Processo di Inclusione - Step Possibilità di Acquisto ${this.toRoman(page + 1)}`
              : 'Processo di Inclusione - Step Possibilità di Acquisto',
            "da parte della struttura, a seguito del recepimento dei termini della gara centralizzata e dell'inserimento del CIG",
          );

          slideIpAcquisto.addTable(
            [this.inclusionAcquistoHeader, ...pageRows],
            {
              fill: { color: 'FFFFFF' },
              x: 0.5,
              y: 1.5,
              colW: [2.0, 3.4, 2.0, 2.0],
              rowH: 0.3,
              valign: 'middle',
              fontSize: 7,
              color: '204131',
              border: { pt: 1.25, color: 'F1F1F1' },
            },
          );
        }
      }
    }

    // Save the presentation
    pptx.writeFile({ fileName: 'Report-Nazionale' });
    this.processMessage = '';
    this.onClose();
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  // first slide decoration: svg ribbons colored with the primary (title) and
  // secondary (subtitle) colors of the report, returned as base64 data uri
  getCoverRibbonsSvg(primaryColor: string, secondaryColor: string): string {
    const toHex = (color: string, fallback: string) =>
      color ? (color.startsWith('#') ? color : `#${color}`) : fallback;
    const primary = toHex(primaryColor, '#141F58');
    const secondary = toHex(secondaryColor, '#00CEBC');

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1655" height="927" viewBox="0 0 1655 927">
  <defs>
    <linearGradient id="primaryRibbon" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="${primary}" stop-opacity="0.08"/>
      <stop offset="38%" stop-color="${primary}" stop-opacity="0.68"/>
      <stop offset="72%" stop-color="${primary}" stop-opacity="0.95"/>
      <stop offset="100%" stop-color="${primary}" stop-opacity="0.12"/>
    </linearGradient>
    <linearGradient id="secondaryRibbon" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="${secondary}" stop-opacity="0.04"/>
      <stop offset="40%" stop-color="${secondary}" stop-opacity="0.72"/>
      <stop offset="70%" stop-color="${secondary}" stop-opacity="0.92"/>
      <stop offset="100%" stop-color="${secondary}" stop-opacity="0.1"/>
    </linearGradient>
    <linearGradient id="finePrimary" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="${primary}" stop-opacity="0.08"/>
      <stop offset="50%" stop-color="${primary}" stop-opacity="0.8"/>
      <stop offset="100%" stop-color="${primary}" stop-opacity="0.18"/>
    </linearGradient>
    <linearGradient id="fineSecondary" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="${secondary}" stop-opacity="0.08"/>
      <stop offset="50%" stop-color="${secondary}" stop-opacity="0.78"/>
      <stop offset="100%" stop-color="${secondary}" stop-opacity="0.16"/>
    </linearGradient>
  </defs>

  <!-- White background -->
  <rect width="1655" height="927" fill="#FFFFFF"/>

  <!-- Main intertwined ribbons -->
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1282 -45 C1322 64 1457 113 1493 216 C1535 337 1390 399 1374 494 C1353 615 1488 653 1444 765 C1418 831 1338 879 1284 969" stroke="url(#secondaryRibbon)" stroke-width="17" opacity="0.42"/>
    <path d="M1371 -35 C1401 73 1517 130 1517 231 C1517 336 1411 401 1411 495 C1410 598 1492 662 1432 752 C1385 824 1320 867 1289 956" stroke="url(#primaryRibbon)" stroke-width="13" opacity="0.56"/>
    <path d="M1421 -40 C1445 71 1544 150 1535 243 C1527 337 1444 398 1440 488 C1434 589 1507 650 1450 739 C1410 802 1350 858 1320 955" stroke="url(#secondaryRibbon)" stroke-width="9" opacity="0.6"/>
    <path d="M1460 -30 C1482 72 1570 159 1551 251 C1532 344 1464 408 1465 494 C1465 589 1522 638 1476 720 C1436 790 1384 844 1356 951" stroke="url(#primaryRibbon)" stroke-width="7" opacity="0.72"/>
  </g>

  <!-- Fine strands -->
  <g fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1280 -35 C1245 95 1341 170 1396 270 C1446 365 1406 440 1471 530 C1536 625 1241 705 1296 810 C1336 870 1351 915 1376 970" stroke="url(#fineSecondary)" stroke-width="0.9" opacity="0.55"/>
    <path d="M1306 -35 C1272 95 1347 170 1402 270 C1452 365 1419 440 1484 530 C1549 625 1251 705 1306 810 C1346 870 1361 915 1386 970" stroke="url(#finePrimary)" stroke-width="0.7" opacity="0.55"/>
    <path d="M1361 -35 C1326 95 1376 170 1431 270 C1481 365 1412 440 1477 530 C1542 625 1278 705 1333 810 C1373 870 1388 915 1413 970" stroke="url(#fineSecondary)" stroke-width="0.8" opacity="0.65"/>
    <path d="M1404 -35 C1369 95 1414 170 1469 270 C1519 365 1431 440 1496 530 C1561 625 1341 705 1396 810 C1436 870 1451 915 1476 970" stroke="url(#finePrimary)" stroke-width="0.75" opacity="0.55"/>
    <path d="M1457 -35 C1422 95 1419 170 1474 270 C1524 365 1428 440 1493 530 C1558 625 1354 705 1409 810 C1449 870 1464 915 1489 970" stroke="url(#fineSecondary)" stroke-width="0.8" opacity="0.55"/>
    <path d="M1513 -35 C1478 95 1435 170 1490 270 C1540 365 1459 440 1524 530 C1589 625 1408 705 1463 810 C1503 870 1518 915 1543 970" stroke="url(#finePrimary)" stroke-width="0.7" opacity="0.65"/>
    <path d="M1315 -20 C1411 115 1466 175 1421 300 C1381 410 1266 455 1321 565 C1381 680 1421 720 1301 840 C1261 890 1241 925 1221 965" stroke="url(#fineSecondary)" stroke-width="0.75" opacity="0.55"/>
    <path d="M1399 -20 C1494 115 1549 175 1504 300 C1464 410 1349 455 1404 565 C1464 680 1504 720 1384 840 C1344 890 1324 925 1304 965" stroke="url(#finePrimary)" stroke-width="0.75" opacity="0.5"/>
  </g>
</svg>`;

    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }

  onClose(): void {
    this.isModalOpen.emit(false); // Emit cancel event
  }

  //Load Complete Italy Map
  async loadExperienceMap(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (this.experienceMapData && this.experienceMapData.length > 0) {
      //  console.log('data', data);

      const regioniData = this.experienceMapData.map((item) => {
        if (item.percentage !== undefined) {
          item.percentage = parseFloat(item.percentage).toFixed(2);
        }

        /*if (Number(item.regionId) === 4) {
          // Find additional data for id5 and combine the tooltip text
          const region5 = data.find(i => Number(i.regionId) === 5);
          if (region5) {
            return {
              ...item,
              tooltipText: `${item.regionName}: ${item.percentage}%<br>${region5.regionName}: ${region5.percentage}%`
            };
          }
        }*/
        // Default tooltip text for other regions
        return {
          ...item,
          tooltipText: `${item.regionName}: <br>${item.percentage}%`,
        };
      });

      this.layersExpMap = [
        {
          shapeData: italyMap,
          shapePropertyPath: 'id',
          shapeDataPath: 'regionId',
          dataSource: regioniData,
          tooltipSettings: {
            visible: true,
            valuePath: 'tooltipText',
            //format: '${regionName}: <br>${percentage}%'
          },
          highlightSettings: {
            enable: false,
          },
          selectionSettings: {
            enable: false,
            fill: '#FFFFFF',
            border: {
              color: '#162456',
              width: 1,
            },
            opacity: 1,
          },

          shapeSettings: {
            //fill: '#088a95',
            //fill: '#088091',

            fill: '#FFFFFF',
            colorValuePath: '#DDE1E5',
            border: {
              color: '#162456',
              width: 0.7,
            },
          },
        },
      ];
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  onExperienceMapLoaded(): void {
    if (!this.experienceMap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.experienceMap as MapsComponent).export(
      'PNG',
      'Maps',
      undefined,
      false,
    );

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then((data: any) => {
        this.experienceMapBase64String = data;
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }

  //Load Complete Italy Map
  async loadRegAccessMap(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    this.heatmapRegionalInclusionColor =
      sessionStorage.getItem('heatmapRegionalInclusionColor') || 'Red';

    const regioniHeatmapData = this.regionalAccessMapData.map((item) => {
      let statusText = '';

      if (item.isCompleted === true) {
        statusText = 'Apertura';
      } else {
        statusText = 'Chiusura';
      }

      return {
        regionId: item.regionId,
        regionName: item.regionName,
        isCompleted: item.isCompleted,
        tooltipText: `${item.regionName}: <br> ${statusText}`,
      };
    });

    this.layersRegAccessMap = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapData,
        tooltipSettings: {
          visible: true,
          valuePath: 'tooltipText',
        },
        highlightSettings: {
          enable: false,
          fill: '#00CEBC',
        },
        selectionSettings: {
          enable: false,
          fill: '',
          opacity: 1,
        },
        shapeSettings: {
          border: {
            color:
              this.heatmapRegionalInclusionColor === 'White'
                ? '#162456'
                : '#FFFFFF',
            width: this.heatmapRegionalInclusionColor === 'White' ? 0.5 : 0.4,
          },
          borderWidth: this.heatmapRegionalInclusionColor === 'White' ? 0.7 : 4,
          colorValuePath: 'isCompleted',
          colorMapping: [
            {
              value: true,
              color: '#008236',
            },
            {
              value: false,
              color:
                this.heatmapRegionalInclusionColor === 'Red'
                  ? '#C10007'
                  : '#FFFFFF',
            },
          ],
        },
      },
    ];

    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  onRegAccessMapLoaded(): void {
    if (!this.regAccessMap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.regAccessMap as MapsComponent).export(
      'PNG',
      'Maps',
      undefined,
      false,
    );

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then(async (data: any) => {
        this.regAccessMapBase64String = await this.resizeBase64(data, 600, 468);
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }
  async loadHeatmap(): Promise<void> {
    this.heatmapColor =
      (sessionStorage.getItem('heatmapColor') as 'Red' | 'White') || 'Red';
    this.heatmapEconomiaColor =
      (sessionStorage.getItem('heatmapEconomiaColor') as 'Red' | 'White') ||
      'White';

    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (this.heatmapData && this.heatmapData.length > 0) {
      const regioniHeatmapData = this.heatmapData.map((item) => {
        // Parse percentage and default to 0 if undefined
        const percentage =
          item.percentage !== undefined
            ? parseFloat(item.percentage).toFixed(2)
            : 0;

        // Default logic for other regions
        return {
          ...item,
          tooltipText: `${item.regionName}: <br> ${percentage}%`,
          percentage, // Use percentage for default colorMapping
          color: '', // Leave blank for colorMapping regions
        };
      });

      this.layersHeatmap = [
        {
          shapeData: italyMap,
          shapePropertyPath: 'id',
          shapeDataPath: 'regionId',
          dataSource: regioniHeatmapData,
          tooltipSettings: {
            visible: true,
            valuePath: 'tooltipText',
          },
          highlightSettings: {
            enable: false,
            fill: '#00CEBC',
          },
          selectionSettings: {
            enable: true,
            fill: '',
            opacity: 1,
          },
          shapeSettings: {
            border: {
              color: this.heatmapColor === 'White' ? '#162456' : '#FFFFFF',
              width: this.heatmapColor === 'White' ? 0.7 : 0.4,
            },
            borderWidth: this.heatmapColor === 'White' ? 0.7 : 4,
            colorValuePath: 'percentage', // Default regions use this
            fill: (properties: any) => {
              const regionData = regioniHeatmapData.find(
                (region: any) => region.regionId === properties.id,
              );
              return regionData && regionData.color ? regionData.color : null; // Use dynamic color for regions 4 and 5
            },
            colorMapping: this.getColorHeatmap(this.heatmapColor),
          },
        },
      ];
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  async loadHeatmapEconomia(): Promise<void> {
    this.heatmapEconomiaColor =
      (sessionStorage.getItem('heatmapEconomiaColor') as 'Red' | 'White') ||
      'White';

    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (!this.heatmapInEconomiaData || this.heatmapInEconomiaData.length === 0)
      return;

    const regioniHeatmapInEconomiaData = this.heatmapInEconomiaData.map(
      (item) => {
        const percentage =
          item.percentage !== undefined
            ? parseFloat(item.percentage).toFixed(2)
            : 0;
        return {
          ...item,
          tooltipText: `${item.regionName}: <br> ${
            item.inEconomia ? percentage + '%' : 'No step'
          }`,
          percentage,
          // Dedicated field for map coloring: sentinel value (-1) falls
          // outside every colorMapping range, so the "value: -1" entry
          // below is the only match and forces the muted color for these regions.
          mapColorValue: !item.inEconomia ? -1 : Number(percentage),
          color: '',
        };
      },
    );

    this.layersHeatmapEconomia = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapInEconomiaData,
        tooltipSettings: { visible: true, valuePath: 'tooltipText' },
        highlightSettings: { enable: false, fill: '#00CEBC' },
        selectionSettings: { enable: true, fill: '', opacity: 1 },
        shapeSettings: {
          border: {
            color:
              this.heatmapEconomiaColor === 'White' ? '#162456' : '#FFFFFF',
            width: this.heatmapEconomiaColor === 'White' ? 0.7 : 0.4,
          },
          borderWidth: this.heatmapEconomiaColor === 'White' ? 0.7 : 4,
          colorValuePath: 'mapColorValue',
          fill: (properties: any) => {
            const regionData = regioniHeatmapInEconomiaData.find(
              (region: any) => region.regionId === properties.id,
            );
            return regionData && regionData.color ? regionData.color : null;
          },
          colorMapping: [
            {
              value: -1,
              color:
                this.heatmapEconomiaColor === 'Red' ? '#454545' : '#D1D9E3',
            },
            ...this.getColorHeatmap(this.heatmapEconomiaColor),
          ],
        },
      },
    ];

    await new Promise((resolve) => setTimeout(resolve, 1500));

    if (this.heatmapEconomia) {
      const promise = (this.heatmapEconomia as MapsComponent).export(
        'PNG',
        'Maps',
        undefined,
        false,
      );
      if (promise) {
        await promise.then(async (data: any) => {
          this.heatmapEconomiaBase64String = await this.resizeBase64(
            data,
            600,
            468,
          );
        });
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 500));
  }

  async loadHeatmapMerged(): Promise<void> {
    if (!this.widgetsAvailable.some((w) => w.id === 15)) return;
    if (!this.heatmapInEconomiaData || this.heatmapInEconomiaData.length === 0)
      return;

    // Reuses the Heatmap Economia API response (this.heatmapInEconomiaData)
    // rendering every region with its value, ignoring the inEconomia flag.
    const regioniHeatmapMergedData = this.heatmapInEconomiaData.map((item) => {
      const percentage =
        item.percentage !== undefined
          ? parseFloat(item.percentage).toFixed(2)
          : 0;
      return {
        ...item,
        tooltipText: `${item.regionName}: <br> ${percentage}%`,
        percentage,
        color: '',
      };
    });

    this.layersHeatmapMerged = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapMergedData,
        tooltipSettings: { visible: true, valuePath: 'tooltipText' },
        highlightSettings: { enable: false, fill: '#00CEBC' },
        selectionSettings: { enable: true, fill: '', opacity: 1 },
        shapeSettings: {
          border: {
            color:
              this.heatmapEconomiaColor === 'White' ? '#162456' : '#FFFFFF',
            width: this.heatmapEconomiaColor === 'White' ? 0.7 : 0.4,
          },
          borderWidth: this.heatmapEconomiaColor === 'White' ? 0.7 : 4,
          colorValuePath: 'percentage',
          fill: (properties: any) => {
            const regionData = regioniHeatmapMergedData.find(
              (region: any) => region.regionId === properties.id,
            );
            return regionData && regionData.color ? regionData.color : null;
          },
          colorMapping: this.getColorHeatmap(this.heatmapEconomiaColor),
        },
      },
    ];

    await new Promise((resolve) => setTimeout(resolve, 1500));

    if (this.heatmapMerged) {
      const promise = (this.heatmapMerged as MapsComponent).export(
        'PNG',
        'Maps',
        undefined,
        false,
      );
      if (promise) {
        await promise.then(async (data: any) => {
          this.heatmapMergedBase64String = await this.resizeBase64(
            data,
            600,
            468,
          );
        });
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 500));
  }

  onHeatMapLoaded(): void {
    if (!this.heatmap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.heatmap as MapsComponent).export(
      'PNG',
      'Maps',
      undefined,
      false,
    );

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then(async (data: any) => {
        this.heatmapBase64String = await this.resizeBase64(data, 600, 468);
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }

  // Helper to format date point "YYYY-MM" to "Month-YY"
  private formatDatePointToIt(datePoint: string): string {
    const [year, month] = datePoint.split('-');
    const idx = Number(month) - 1;
    return `${this.monthNamesIt[idx]} ${year}`; //
  }

  private formatDatePointToAxis(datePoint: string): string {
    const [year, month] = datePoint.split('-');
    return `${month}\n${year}`;
  }

  private hasOpenToMarket30DaysWidget(id: 21 | 23): boolean {
    return this.widgetsAvailable.some((w) => w.id === id);
  }

  private addCurveLegend(
    pptx: PptxGenJS,
    slide: PptxGenJS.Slide,
    x: number,
    y: number,
  ): void {
    const items = [
      { name: 'Forecast', color: '00CEBC' },
      { name: 'Actual', color: '141E58' },
    ];

    items.forEach((item, index) => {
      const itemX = x + index * 0.77;

      slide.addShape(pptx.ShapeType.roundRect, {
        x: itemX,
        y: y + 0.045,
        w: 0.07,
        h: 0.07,
        rectRadius: 0.02,
        fill: { color: item.color },
        line: { color: item.color },
      });

      slide.addText(item.name, {
        x: itemX + 0.12,
        y: y,
        w: 0.55,
        h: 0.16,
        margin: 0,
        fontSize: 6,
        fontFace: this.brandInfoMedicine.font.title,
        color: '6B7280',
        valign: 'middle',
      });
    });
  }

  private buildCumulativeSeries(
    labels: string[],
    points: { month: string; value: number }[],
    options: { capToCurrentMonth?: boolean } = {},
  ): (number | null)[] {
    const acc = this.faAccumulate(points, true);

    if (!options.capToCurrentMonth) {
      return this.faBuildSeries(labels, acc, true);
    }

    const now = new Date();
    const currentNum = this.faYmToNum(
      `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
    );
    return this.faBuildSeries(labels, acc, true, currentNum, true);
  }

  // --- widget-curva-mercato-30-giorni (id: 21) ---

  // Same processing as OpenToMarketCurve30DaysComponent: labels are relative periods
  // ("Month 0", "Month 1"...) and every point carries startPeriodDate/endPeriodDate.
  // Cumulative values with carry-forward; Actual stops at the current period and at 100%.
  private buildOpenToMarket30DaysSeries(data: any): void {
    this.openToMarket30DaysLabels = [];
    this.openToMarket30DaysTargetData = [];
    this.openToMarket30DaysActualData = [];
    this.openToMarket30DaysTableData = [];
    this.openToMarket30DaysMergedTableData = [];
    this.openToMarket30DaysForecastPeriods = [];
    this.openToMarket30DaysActualPeriods = [];

    const target: any[] = data?.target ?? [];
    const actual: any[] = data?.actual ?? [];
    const indexOf = (input: string): number =>
      Number(String(input).match(/(\d+)/)?.[1] ?? NaN);

    const indexes = [...new Set<number>((data?.labels ?? []).map(indexOf))]
      .filter((n) => !isNaN(n))
      .sort((a, b) => a - b);
    const hasValues = [...target, ...actual].some((p) => p?.value != null);
    if (indexes.length === 0 || !hasValues) return;

    const accumulate = (points: any[]): Map<number, number> => {
      const sums = new Map<number, number>();
      for (const p of points) {
        const k = indexOf(p.month);
        if (isNaN(k)) continue;
        const roundedValue = Math.round(Number(p.value) * 100) / 100;
        sums.set(k, (sums.get(k) ?? 0) + roundedValue);
      }
      const acc = new Map<number, number>();
      let running = 0;
      for (const k of [...sums.keys()].sort((a, b) => a - b)) {
        running = Math.round((running + sums.get(k)!) * 100) / 100;
        acc.set(k, running);
      }
      return acc;
    };

    const buildSeries = (
      acc: Map<number, number>,
      maxIndex?: number,
      stopAt100?: boolean,
    ): (number | null)[] => {
      const startIndex = acc.size ? Math.min(...acc.keys()) : null;
      const out: (number | null)[] = [];
      let last: number | undefined;
      let reachedMax = false;
      for (const idx of indexes) {
        if (
          startIndex == null ||
          idx < startIndex ||
          (maxIndex != null && idx > maxIndex) ||
          (stopAt100 && reachedMax)
        ) {
          out.push(null);
          continue;
        }
        const v = acc.get(idx) ?? last;
        if (v == null) {
          out.push(null);
          continue;
        }
        out.push(v);
        last = v;
        if (stopAt100 && v >= 100) reachedMax = true;
      }
      return out;
    };

    const periodDates = new Map<number, { start: string; end: string }>();
    [...target, ...actual].forEach((p) => {
      const idx = indexOf(p.month);
      if (!isNaN(idx) && p.startPeriodDate && p.endPeriodDate) {
        periodDates.set(idx, {
          start: p.startPeriodDate,
          end: p.endPeriodDate,
        });
      }
    });

    // Current period = last period already started (no dates -> no cap)
    let currentIndex: number | undefined;
    if (periodDates.size > 0) {
      const today = new Date();
      currentIndex = -1;
      periodDates.forEach((period, idx) => {
        if (new Date(period.start) <= today && idx > currentIndex!)
          currentIndex = idx;
      });
    }

    const parseYmd = (date: any): Date | null => {
      const m = String(date ?? '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return null;
      return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    };

    const toText = (date: Date) =>
      `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

    // same rule as the 30 days curve widget: Month 1 = [Step 0, Step 0 + 1 month],
    // Month N = [Step 0 + (N-1) months + 1 day, Step 0 + N months], Month 0 has no range
    const addMonthsFromStart = (start: Date, n: number): Date => {
      const lastDay = new Date(
        start.getFullYear(),
        start.getMonth() + n + 1,
        0,
      ).getDate();
      return new Date(
        start.getFullYear(),
        start.getMonth() + n,
        Math.min(start.getDate(), lastDay),
      );
    };

    const buildPeriods = (stepZero: any, points: any[]): string[] => {
      const apiPeriods = new Map<number, string>();
      points.forEach((p) => {
        const idx = indexOf(p.month);
        const start = parseYmd(p.startPeriodDate);
        const end = parseYmd(p.endPeriodDate);
        if (idx > 0 && start && end) {
          apiPeriods.set(idx, `${toText(start)} - ${toText(end)}`);
        }
      });

      const start =
        parseYmd(stepZero) ??
        parseYmd(points.find((p) => indexOf(p.month) === 1)?.startPeriodDate);

      return indexes.map((idx) => {
        if (idx <= 0) return '';
        if (!start) return apiPeriods.get(idx) ?? '';

        const end = addMonthsFromStart(start, idx);
        if (idx === 1) return `${toText(start)} - ${toText(end)}`;

        const prevEnd = addMonthsFromStart(start, idx - 1);
        const periodStart = new Date(
          prevEnd.getFullYear(),
          prevEnd.getMonth(),
          prevEnd.getDate() + 1,
        );
        return `${toText(periodStart)} - ${toText(end)}`;
      });
    };

    this.openToMarket30DaysForecastPeriods = buildPeriods(
      data?.forecastStartDate,
      target,
    );
    this.openToMarket30DaysActualPeriods = buildPeriods(
      data?.actualStartDate,
      actual,
    );
    this.openToMarket30DaysLabels = indexes.map((idx) => 'Mese ' + idx);
    this.openToMarket30DaysTargetData = buildSeries(accumulate(target));
    this.openToMarket30DaysActualData = buildSeries(
      accumulate(actual),
      currentIndex,
      true,
    );
  }

  // values are clamped to 0-100 like the charts, so table and curves always match
  async loadOpenToMarket30Days(): Promise<void> {
    const clamp = (v: number | null) =>
      v == null ? null : Math.min(100, Math.max(0, v));
    const cellOptions = {
      fontSize: 6.5,
      fontFace: this.brandInfoMedicine.font.title,
      color: '000000',
    };

    const rows = this.openToMarket30DaysLabels.map((label, idx) => {
      // Mese 0 is always 0.00: shown as "-" in forecast, actual and delta
      const isMonthZero = label === 'Mese 0';
      const forecastVal = isMonthZero
        ? null
        : clamp(this.openToMarket30DaysTargetData[idx]);
      const actualVal = isMonthZero
        ? null
        : clamp(this.openToMarket30DaysActualData[idx]);

      const delta =
        forecastVal != null && actualVal != null
          ? Math.round((actualVal - forecastVal) * 100) / 100
          : null;

      const deltaFill = this.getDeltaFillColor({
        mese: '',
        forecast: forecastVal,
        actual: actualVal,
        delta,
      });

      return [
        { text: label, options: { ...cellOptions, align: 'left' } },
        {
          text: forecastVal != null ? `${forecastVal.toFixed(2)}%` : '-',
          options: { ...cellOptions, align: 'center' },
        },
        {
          text: actualVal != null ? `${actualVal.toFixed(2)}%` : '-',
          options: { ...cellOptions, align: 'center' },
        },
        {
          text:
            delta != null ? `${delta > 0 ? '+' : ''}${delta.toFixed(2)}%` : '-',
          options: { ...cellOptions, align: 'center', fill: deltaFill },
        },
      ];
    });

    this.openToMarket30DaysTableData = [
      this.openToAccessAndMarketHeader,
      ...rows,
    ];

    const withPeriod = (cell: any, period: string) => {
      if (!period) return cell;
      return {
        text: [
          { text: cell.text, options: { breakLine: true } },
          { text: period, options: { color: '555555' } },
        ],
        options: cell.options,
      };
    };

    const mergedRows = rows.map((row, idx) => [
      row[0],
      withPeriod(row[1], this.openToMarket30DaysForecastPeriods[idx]),
      withPeriod(row[2], this.openToMarket30DaysActualPeriods[idx]),
      row[3],
    ]);

    this.openToMarket30DaysMergedTableData = [
      this.openToAccessAndMarketHeader,
      ...mergedRows,
    ];

    // let the loading message render before the next step
    await new Promise((resolve) => setTimeout(resolve, 300));
  }

  private addOpenToMarket30DaysSlideHeader(
    slide: PptxGenJS.Slide,
    widgetName?: string,
  ): void {
    slide.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title,
      color: this.brandInfoMedicine.colors.title,
      bold: true,
      align: 'left',
    });

    slide.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%',
    });

    if (widgetName) {
      slide.addText(widgetName, {
        x: 0.5,
        y: 0.6,
        w: '70%',
        h: '8%',
        fontSize: 14,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: this.brandInfoMedicine.colors.subtitle,
        bold: true,
        align: 'left',
      });
    }

    slide.addText(
      TOOLTIPS_NT.find((t) => t.id === 21)?.text ||
        'Apertura a livello Ospedaliero aggregata per periodi di 30 giorni dalla data di lancio: Forecast (sopra) e Actual (sotto)',
      {
        x: 0.5,
        y: 0.92,
        w: '93%',
        h: '8%',
        fontSize: 9.5,
        fontFace: this.brandInfoMedicine.font.subtitle,
        color: '000000',
        bold: false,
        align: 'left',
      },
    );
  }

  private addOpenToMarket30DaysCharts(
    pptx: PptxGenJS,
    slide: PptxGenJS.Slide,
    box: { x: number; y: number; w: number; h: number },
    showValue: boolean,
  ): void {
    const clamp = (v: number | null) =>
      v == null ? null : Math.min(100, Math.max(0, v));
    const labels = this.openToMarket30DaysLabels;
    const forecast = this.openToMarket30DaysTargetData.map(clamp);

    let lastActualIndex = -1;
    for (let i = this.openToMarket30DaysActualData.length - 1; i >= 0; i--) {
      if (this.openToMarket30DaysActualData[i] != null) {
        lastActualIndex = i;
        break;
      }
    }
    const actual = this.openToMarket30DaysActualData
      .slice(0, lastActualIndex + 1)
      .map(clamp);

    const chartH = box.h / 2;
    const series = [
      { name: 'Forecast', color: '00CEBC', values: forecast, y: box.y },
      { name: 'Actual', color: '141E58', values: actual, y: box.y + chartH },
    ];

    series.forEach((s) => {
      slide.addChart(
        pptx.ChartType.line,
        [{ name: s.name, labels, values: s.values as number[] }],
        {
          x: box.x,
          y: s.y,
          w: box.w,
          h: chartH,

          showTitle: true,
          title: s.name,
          titleFontFace: this.brandInfoMedicine.font.title,
          titleFontSize: 8,
          titleColor: s.color,
          titleBold: true,
          showLegend: false,

          lineSize: 1.5,
          lineDataSymbol: 'circle',
          lineDataSymbolSize: 4,
          lineDataSymbolLineSize: 0,

          showValue,
          dataLabelFormatCode: '0.00;;',
          dataLabelFontFace: this.brandInfoMedicine.font.title,
          dataLabelFontSize: 5,
          dataLabelColor: '000000',
          dataLabelPosition: 't',

          valAxisMinVal: 0,
          valAxisMaxVal: 105,
          valAxisMajorUnit: 20,
          valAxisLabelFormatCode: '0"%"',
          valAxisLabelFontFace: this.brandInfoMedicine.font.title,
          valAxisLabelFontSize: 5,
          valAxisLabelColor: '555555',
          valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

          catAxisLabelFontFace: this.brandInfoMedicine.font.title,
          catAxisLabelFontSize: 5,
          catAxisLabelColor: '555555',
          catAxisLabelRotate: -45,
          catAxisLineShow: false,
          catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

          plotArea: { fill: { color: 'FFFFFF' } },
          chartArea: {
            fill: { color: 'FFFFFF' },
            border: { pt: 0, color: 'FFFFFF' },
          },
          chartColors: [s.color],
        },
      );
    });
  }

  private buildCurveChartTypes(
    pptx: PptxGenJS,
    labels: string[],
    forecast: (number | null)[],
    actual: (number | null)[],
  ): any[] {
    const forecastValues = labels.map((_, index) => forecast[index] ?? null);
    const actualValues = labels.map((_, index) => actual[index] ?? null);

    const forecastOnTop = labels.map((_, index) => {
      const forecastValue = forecastValues[index];
      const actualValue = actualValues[index];
      if (forecastValue != null && actualValue != null) {
        return forecastValue >= actualValue;
      }
      return true;
    });

    const actualOnTop = labels.map((_, index) => {
      const forecastValue = forecastValues[index];
      const actualValue = actualValues[index];
      if (forecastValue != null && actualValue != null) {
        return actualValue > forecastValue;
      }
      return actualValue != null && actualValue <= 6;
    });

    return [
      ...this.buildSeriesChartTypes(
        pptx,
        'Forecast',
        '#00CEBC',
        labels,
        forecastValues,
        forecastOnTop,
      ),
      ...this.buildSeriesChartTypes(
        pptx,
        'Actual',
        '#141F58',
        labels,
        actualValues,
        actualOnTop,
      ),
    ];
  }

  private buildSeriesChartTypes(
    pptx: PptxGenJS,
    name: string,
    color: string,
    labels: string[],
    values: (number | null)[],
    onTop: boolean[],
  ): any[] {
    const isNearBottom = values.map(
      (value, index) =>
        !onTop[index] && value != null && value > 0 && value < 6,
    );
    const valuesAbove = values.map((value, index) =>
      onTop[index] ? value : null,
    );
    const valuesBelow = values.map((value, index) =>
      onTop[index] || isNearBottom[index] ? null : value,
    );
    const colors = Array(labels.length * 2 + 6).fill(color);

    const nearBottomChartTypes: any[] = [];
    values.forEach((value, index) => {
      if (value == null || !isNearBottom[index]) {
        return;
      }

      nearBottomChartTypes.push({
        type: pptx.ChartType.line,
        data: [
          {
            name,
            labels,
            values: labels.map((_, i) => (i === index ? value + 2.3 : null)),
          },
        ],
        options: {
          chartColors: colors,
          lineSize: 0,
          lineDataSymbol: 'none',
          dataLabelPosition: 'b',
          dataLabelFormatCode: `"${value.toFixed(2)}";;`,
        },
      });
    });

    return [
      {
        type: pptx.ChartType.line,
        data: [{ name, labels, values }],
        options: { chartColors: colors, showValue: false },
      },
      {
        type: pptx.ChartType.line,
        data: [{ name, labels, values: valuesAbove }],
        options: {
          chartColors: colors,
          lineSize: 0,
          lineDataSymbol: 'none',
          dataLabelPosition: 't',
          dataLabelFormatCode: '0.00;;',
        },
      },
      {
        type: pptx.ChartType.line,
        data: [{ name, labels, values: valuesBelow }],
        options: {
          chartColors: colors,
          lineSize: 0,
          lineDataSymbol: 'none',
          dataLabelPosition: 'b',
          dataLabelFormatCode: '0.00;;',
        },
      },
      ...nearBottomChartTypes,
    ];
  }

  private faToYm(input: string | Date): string {
    if (input instanceof Date && !isNaN(input.getTime())) {
      const y = input.getFullYear();
      const m = String(input.getMonth() + 1).padStart(2, '0');
      return `${y}-${m}`;
    }
    const raw = String(input).trim();
    const m = raw.match(/^(\d{4})-?(\d{2})(?:-?\d{2})?$/);
    if (!m) throw new Error(`Bad month format: ${raw}`);
    return `${m[1]}-${m[2]}`;
  }

  private faYmToNum(ym: string): number {
    const [y, m] = ym.split('-').map(Number);
    return y * 100 + m;
  }

  private faSortLabelsChrono(labels: string[]): string[] {
    return [...labels]
      .map((l) => this.faToYm(l))
      .sort((a, b) => this.faYmToNum(a) - this.faYmToNum(b));
  }

  private faAccumulate(
    points: { month: string; value: number }[],
    roundPerPoint: boolean,
  ): Map<string, number> {
    const sums = new Map<string, number>();
    for (const p of points || []) {
      const k = this.faToYm(p.month);
      const value = roundPerPoint
        ? Math.round(Number(p.value) * 100) / 100
        : Number(p.value);
      sums.set(k, (sums.get(k) ?? 0) + value);
    }
    const months = [...sums.keys()].sort(
      (a, b) => this.faYmToNum(a) - this.faYmToNum(b),
    );
    const acc = new Map<string, number>();
    let running = 0;
    for (const m of months) {
      running += sums.get(m)!;
      running = Math.round(running * 100) / 100;
      acc.set(m, running);
    }
    return acc;
  }

  private faFirstMonthNum(acc: Map<string, number>): number | null {
    if (acc.size === 0) return null;
    return Math.min(...[...acc.keys()].map((k) => this.faYmToNum(k)));
  }

  private faBuildSeries(
    labels: string[],
    acc: Map<string, number>,
    carryForward: boolean,
    maxMonthNum?: number,
    stopAt100?: boolean,
  ): (number | null)[] {
    const startNum = this.faFirstMonthNum(acc);
    const out: (number | null)[] = [];
    let last: number | undefined;
    let reachedMax = false;

    for (const label of labels) {
      const num = this.faYmToNum(label);
      if (startNum == null || num < startNum) {
        out.push(null);
        continue;
      }
      if (maxMonthNum != null && num > maxMonthNum) {
        out.push(null);
        continue;
      }
      if (stopAt100 && reachedMax) {
        out.push(null);
        continue;
      }

      const v = acc.get(label);
      if (v != null) {
        out.push(v);
        last = v;
        if (stopAt100 && v >= 100) reachedMax = true;
      } else if (carryForward && last != null) {
        out.push(last);
        if (stopAt100 && last >= 100) reachedMax = true;
      } else {
        out.push(null);
      }
    }
    return out;
  }

  private buildForecastAccuracyRows(
    infoData: NtChartRegionInterface,
    roundPerPoint: boolean,
  ): ForecastAccuracyRow[] {
    const labelsRaw: string[] = infoData.labels || [];
    const labels = this.faSortLabelsChrono(labelsRaw);

    const targetAcc = this.faAccumulate(infoData.target || [], roundPerPoint);
    const actualAcc = this.faAccumulate(infoData.actual || [], roundPerPoint);

    const now = new Date();
    const currentNum = this.faYmToNum(
      `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
    );

    const forecastValues = this.faBuildSeries(labels, targetAcc, true);
    const actualValues = this.faBuildSeries(
      labels,
      actualAcc,
      true,
      currentNum,
      true,
    );

    return labels.map((_, index) => {
      const forecast = forecastValues[index];
      const actual = actualValues[index];
      const delta =
        forecast != null && actual != null
          ? Math.round((actual - forecast) * 100) / 100
          : null;

      return {
        mese: `Mese ${index + 1}`,
        forecast,
        actual,
        delta,
      };
    });
  }

  // Mirrors getDeltaClass() from forecast-accuracy-open-to-access/-economia/-market
  // components: bg-green-500 / bg-green-200 / bg-green-50 by |delta| range.
  private getDeltaFillColor(row: ForecastAccuracyRow): string {
    const { delta, forecast, actual } = row;

    if (delta == null) return 'FFFFFF';

    // exact 0/0 case: no background
    if (forecast === 0 && actual === 0) return 'FFFFFF';

    const absDelta = Math.abs(delta);

    if (absDelta <= 1) return '22C55E'; // bg-green-500
    if (absDelta <= 2) return 'BBF7D0'; // bg-green-200
    if (absDelta <= 3) return 'EAF7EC'; // bg-delta-light

    return 'FFFFFF';
  }

  private mapForecastAccuracyRowsToPptTable(
    rows: ForecastAccuracyRow[],
  ): any[] {
    const bodyRows = rows.map((row) => {
      const deltaFill = this.getDeltaFillColor(row);

      return [
        {
          text: row.mese,
          options: {
            align: 'left',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: row.forecast != null ? `${row.forecast.toFixed(2)}%` : '-',
          options: {
            align: 'center',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: row.actual != null ? `${row.actual.toFixed(2)}%` : '-',
          options: {
            align: 'center',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
          },
        },
        {
          text: row.delta != null ? `${row.delta.toFixed(2)}%` : '-',
          options: {
            align: 'center',
            fontSize: 6.5,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000',
            fill: deltaFill,
          },
        },
      ];
    });

    return [this.forecastAccuracyHeader, ...bodyRows];
  }

  private normalizeDateString(due: string): string {
    if (!due) return '';
    return due.replace(/[^0-9]/g, '');
  }

  formatDate(due: string): string {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 'No Data';

    const year = cleanDue.substring(0, 4);
    const month = cleanDue.substring(4, 6);
    const day = cleanDue.substring(6, 8);

    return `${day}/${month}/${year}`;
  }

  compareDates(due: string): number {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 0;

    const year = parseInt(cleanDue.substring(0, 4), 10);
    const month = parseInt(cleanDue.substring(4, 6), 10) - 1;
    const day = parseInt(cleanDue.substring(6, 8), 10);

    const dueDate = new Date(year, month, day);
    dueDate.setHours(0, 0, 0, 0);

    const delta = Math.round(
      (this.today.getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24),
    );
    return delta;
  }
  // For the Heatmap
  getColorHeatmap(mode: string): any[] {
    if (mode === 'Red') {
      return [
        { from: 0, to: 0, color: '#c10007' },
        { from: 0.01, to: 8.33, color: '#dd3a3f' },
        { from: 8.34, to: 16.66, color: '#e95b43' },
        { from: 16.67, to: 24.99, color: '#f47938' },
        { from: 25.0, to: 33.32, color: '#fba63a' },
        { from: 33.33, to: 41.65, color: '#ffd04c' },
        { from: 41.66, to: 49.98, color: '#ffe84a' },
        { from: 49.99, to: 58.31, color: '#e4f042' },
        { from: 58.32, to: 66.64, color: '#c5e73c' },
        { from: 66.65, to: 74.97, color: '#9fdd38' },
        { from: 74.98, to: 83.3, color: '#7cca33' },
        { from: 83.31, to: 91.63, color: '#51b42f' },
        { from: 91.64, to: 99.99, color: '#2e9c2b' },
        { from: 100, to: 100, color: '#008236' },
      ];
    } else {
      // White mode
      return [
        { from: 0, to: 0, color: '#ffffff' }, // bianco
        { from: 0.01, to: 8.33, color: '#f8f8f8' }, // grigio leggerissimo (un pelo più scuro)
        { from: 8.34, to: 16.66, color: '#eaeaea' }, // grigio molto chiaro (appena più scuro)
        { from: 16.67, to: 24.99, color: '#e0e0e0' }, // grigio chiaro (più differenziato)
        { from: 25.0, to: 33.32, color: '#d0d0b3' }, // grigio con un filo di giallo
        { from: 33.33, to: 41.65, color: '#d0d09c' }, // grigio con un pelo di giallo in più
        { from: 41.66, to: 49.98, color: '#c4c44d' }, // giallo/verde
        { from: 49.99, to: 58.31, color: '#9fbf4d' }, // verde/giallo
        { from: 58.32, to: 66.64, color: '#7fb34d' }, // verde
        { from: 66.65, to: 74.97, color: '#60a34d' }, // verde medio
        //{ from: 74.98, to: 83.3, color: '#40934d' }, // verde brillante
        { from: 74.98, to: 83.3, color: '#449E51' }, // verde brillante
        //{ from: 83.31, to: 91.63, color: '#2e7d32' }, // verde scuro
        { from: 83.31, to: 91.63, color: '#3C9841' }, // verde scuro
        //{ from: 91.64, to: 99.99, color: '#1b5e20' }, // verde molto scuro
        { from: 91.64, to: 99.99, color: '#43a047' }, // verde molto scuro
        { from: 100, to: 100, color: '#008236' }, // verde intenso
      ];
    }
  }

  // helper for Bolzano and Trento region names
  formatRegionName(regionName: string): string {
    if (!regionName) return '';

    if (regionName === 'Prov. Aut. di Bolzano') {
      return 'PA di Bolzano';
    } else if (regionName === 'Prov. Aut. di Trento') {
      return 'PA di Trento';
    }
    return regionName;
  }

  private formatInclusionDate(value: string | null | undefined): string {
    if (!value) return '-';
    const formatted = this.formatDate(value);
    return formatted === 'No Data' ? '-' : formatted;
  }

  private getInclusionStatusLabel(
    status: string,
    dueDate?: string | null,
  ): string {
    if (status !== 'COMPLETED' && dueDate && this.compareDates(dueDate) > 0) {
      return 'In Ritardo';
    }
    const statusMap: { [key: string]: string } = {
      COMPLETED: 'Completato',
      IN_PROGRESS: 'In Corso',
      OPEN: 'Non Completato',
    };
    return statusMap[status] ?? '-';
  }

  private getInclusionStatusFillColor(statusLabel: string): string {
    switch (statusLabel) {
      case 'Completato':
        return 'CCF7DD'; // green
      case 'In Corso':
        return 'FFECA1'; // yellow
      case 'In Ritardo':
        return 'FDE0E0'; // red
      default:
        return 'FFFFFF';
    }
  }

  private toRoman(num: number): string {
    const romanMap: [number, string][] = [
      [1000, 'M'],
      [900, 'CM'],
      [500, 'D'],
      [400, 'CD'],
      [100, 'C'],
      [90, 'XC'],
      [50, 'L'],
      [40, 'XL'],
      [10, 'X'],
      [9, 'IX'],
      [5, 'V'],
      [4, 'IV'],
      [1, 'I'],
    ];
    let remaining = num;
    let result = '';
    for (const [value, numeral] of romanMap) {
      while (remaining >= value) {
        result += numeral;
        remaining -= value;
      }
    }
    return result;
  }

  private resizeBase64(
    base64: string,
    targetW: number,
    targetH: number,
  ): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext('2d')!;
        const scale = Math.min(targetW / img.width, targetH / img.height);
        const scaledW = img.width * scale;
        const scaledH = img.height * scale;
        const offsetX = (targetW - scaledW) / 2;
        const offsetY = (targetH - scaledH) / 2;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, targetW, targetH);
        ctx.drawImage(img, offsetX, offsetY, scaledW, scaledH);
        resolve(canvas.toDataURL('image/png'));
      };
      img.src = base64;
    });
  }

  // used to split in two parts the evoluzione timeline
  private splitTableByColumns(
    tableData: any[][],
    maxCols: number = 7,
  ): any[][][] {
    if (!tableData || tableData.length === 0) return [];

    const totalCols = tableData[0].length;

    // don't include the first column
    const dataCols = totalCols - 1;

    const chunks: any[][][] = [];

    for (let start = 0; start < dataCols; start += maxCols) {
      const end = start + maxCols;

      const chunk = tableData.map((row, rowIndex) => {
        const firstCell = row[0]; // Forecast / Actual / empty header
        const sliced = row.slice(start + 1, end + 1);

        return [firstCell, ...sliced];
      });

      chunks.push(chunk);
    }

    return chunks;
  }

  // needed to apply the customized color on all the headers that are structured before the render
  applyBrandToAllHeaders() {
    this.updateHeaderColors(this.medicineInfoHeader);
    this.updateHeaderColors(this.medicineTherapeuticInfoHeader);
    this.updateHeaderColors(this.activitySummaryHeader);
    this.updateHeaderColors(this.openToAccessAndMarketHeader);
    this.updateHeaderColors(this.monitorinForecastvsActualHeader);
    this.updateHeaderColors(this.regionalAccessHeader);
    this.updateHeaderColors(this.experienceAndHospitalsTotalHeader);
    this.updateHeaderColors(this.inclusionStartHeader);
    this.updateHeaderColors(this.inclusionRegionHeader);
    this.updateHeaderColors(this.inclusionAcquistoHeader);
    this.updateHeaderColors(this.forecastAccuracyHeader);

    // FORECAST / ACTUAL header text keep fixed colors regardless of medicine brand
    this.pinForecastActualColors(this.openToAccessAndMarketHeader, 1, 2);
    this.pinForecastActualColors(this.monitorinForecastvsActualHeader, 1, 2);
    this.pinForecastActualColors(this.inclusionStartHeader, 1, 2);
    this.pinForecastActualColors(this.inclusionRegionHeader, 1, 2);
    this.pinForecastActualColors(this.inclusionAcquistoHeader, 2, 3);
    this.pinForecastActualColors(this.forecastAccuracyHeader, 1, 2);
  }

  private pinForecastActualColors(
    header: any[],
    forecastIdx: number,
    actualIdx: number,
  ): void {
    if (header[forecastIdx]) header[forecastIdx].options.color = '00CEBC';
    if (header[actualIdx]) header[actualIdx].options.color = '141E58';
  }

  updateHeaderColors(headers: any[]) {
    const color = this.brandInfoMedicine.colors.title.replace('#', '');

    headers.forEach((h) => {
      // Skip cells that have a non-white colored fill (e.g. status columns COMPLETATA, IN CORSO, IN RITARDO, NESSUNA DATA)
      if (h.options && (!h.options.fill || h.options.fill === 'FFFFFF')) {
        h.options.color = color;
      }
    });
  }
}
